import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { KUService } from '../ku-service.service';
import { Kultur } from '../kultur';
import { BubbleController, Chart, ChartData, ChartOptions } from 'chart.js';
import * as annotation from 'chartjs-plugin-annotation';
import { LineAnnotationOptions } from 'chartjs-plugin-annotation'; //annotation from 'chartjs-plugin-annotation';
import { R3TargetBinder } from '@angular/compiler';
import { MatGridTileHeaderCssMatStyler } from '@angular/material/grid-list';
import { BaseChartDirective } from 'ng2-charts';


@Component({
  selector: 'app-kultur',
  templateUrl: './app-kultur.component.html',
  styleUrls: ['./app-kultur.component.scss']
})
export class AppkulturComponent implements OnInit {


  //  ChartAnnotation=require('chartjs-plugin-annotation');
  // @ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined;
 


  @ViewChild("myChart") mycanvas!: ElementRef;
   chartfontsize: number = 12;

 

  plusminusData: ChartData<'line'> = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May'],
    datasets: [
      { label: 'Mobiles', data: [1000, 1200, 1050, 2000, 500], tension: 0.5 },
      { label: 'Laptop', data: [200, 100, 400, 50, 90], tension: 0.5 },
      { label: 'AC', data: [500, 400, 350, 450, 650], tension: 0.5 },
      { label: 'Headset', data: [1200, 1500, 1020, 1600, 900], tension: 0.5 },
    ],
  };

  pieTagzuHolzData: ChartData<'pie'> = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May'],
    datasets: [
      { label: 'Mobiles', data: [1000, 1200, 1050, 2000, 500] },
      { label: 'Laptop', data: [200, 100, 400, 50, 90] },
      { label: 'AC', data: [500, 400, 350, 450, 650] },
      { label: 'Headset', data: [1200, 1500, 1020, 1600, 900] },
    ],
  };
  annotation1 = {
    type: 'line',
    borderColor: 'black',
    borderWidth: 5,
    click: function ({ chart, element }) {
  
    },
    label: {
      backgroundColor: 'red',
      content: 'Test Label',
      enabled: true
    },
    scaleID: 'y',
    value: 17
  };

  verlauf_labels=[];
  verlauf_data=[];


  chartplusminusOptions: ChartOptions = {
    responsive: true,
    //  backgroundColor: 'black',

    plugins: {

      annotation: {
        annotations://{//this.annotation1,
          [{
            type: 'line',
            borderColor: 'black',
            borderWidth: 5,
            click: function ({ chart, element }) {
         
            },
            label: {
              backgroundColor: 'red',
              content: 'Test Label',
              enabled: true
            },
            scaleID: 'y',
            value: 26,//Utils.rand(-100, 100)
          }],
        drawTime: "beforeDraw" //afterDraw"*/
      }
      ,

      title: {
        display: false,
        text: '+ / - Übersicht um im &#216 der Gruppe zu sein',
        font: {
          size: this.chartfontsize
        },
      },
      legend: {
        labels: {
          font: {
            size:  this.chartfontsize
          }

        }
      },
      tooltip: {
        bodyFont: {
          size:  this.chartfontsize
        },
      //  titleFont: {
       //   size: 20
       // }
      }

    },
    color: 'black',
    scales: {
      xAxes: {
        ticks: {
          font: {
            size:  this.chartfontsize
          }

        }
      }
    },
  };


  TagschichtenData: ChartData<'line'> = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May'],
    datasets: [
      { label: 'Mobiles', data: [1000, 1200, 1050, 2000, 500], tension: 0.5 },
      { label: 'Laptop', data: [200, 100, 400, 50, 90], tension: 0.5 },
      { label: 'AC', data: [500, 400, 350, 450, 650], tension: 0.5 },
      { label: 'Headset', data: [1200, 1500, 1020, 1600, 900], tension: 0.5 },
    ],
  };
  chartTagschichtenOptions: ChartOptions = {
    responsive: true,
    backgroundColor: 'green',
    plugins: {
      title: {
        display: false,
        text: 'Absolut Tagschichten und Holz Übersicht',
        font: {
          size:  this.chartfontsize
        },
      },
      legend: {
        labels: {
          font: {
            size:  this.chartfontsize
          },


        }
      },
      tooltip: {
        bodyFont: {
          size:  this.chartfontsize
        },
        titleFont: {
          size:  this.chartfontsize
        }
      },


    },
    scales: {
      xAxes: {
        ticks: {
          font: {
            size: this.chartfontsize
          }

        }
      }
    }
  };

  HolzzuTagschichtenData: ChartData<'line'> = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May'],
    datasets: [
      { label: 'Mobiles', data: [1000, 1200, 1050, 2000, 500], tension: 0.5 },
      { label: 'Laptop', data: [200, 100, 400, 50, 90], tension: 0.5 },
      { label: 'AC', data: [500, 400, 350, 450, 650], tension: 0.5 },
      { label: 'Headset', data: [1200, 1500, 1020, 1600, 900], tension: 0.5 },
    ],
  };

  chartHolzzuTagschichtenOptions: ChartOptions = {
    responsive: true,
   // backgroundColor: 'green',
    plugins: {
      annotation: {
        annotations: [
          {
            type: 'line',
            //  mode: 'vertical',
            scaleID: 'x-axis-0',
            value: '2020-10-05',
            borderColor: 'red',
            borderWidth: 2,
            label: {
              content: 'TODAY',
              enabled: true,
              position: 'top'
            }
          }
        ]
      },
      title: {
        display: false,
        text: 'Tagschichten/Holz[srm] Übersicht',
        font: {
          size:  this.chartfontsize
        },
      },
      legend: {
        labels: {
          font: {
            size: this.chartfontsize
          },
        }
      },
      tooltip: {
        bodyFont: {
          size:  this.chartfontsize
        },
        titleFont: {
          size:  this.chartfontsize
        }
      },
    },
    scales: {
      xAxes: {
        ticks: {
          font: {
            size:  this.chartfontsize
          }
        }
      }
    }
  };

  VerlaufData: ChartData<'line'> = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May'],
    datasets: [
      { label: 'Mobiles', data: [1000, 1200, 1050, 2000, 500], tension: 0.5 },
      { label: 'Laptop', data: [200, 100, 400, 50, 90], tension: 0.5 },
      { label: 'AC', data: [500, 400, 350, 450, 650], tension: 0.5 },
      { label: 'Headset', data: [1200, 1500, 1020, 1600, 900], tension: 0.5 },
    ],
  };


  VerlaufTagzuHolzData: ChartData<'line'> = {
    labels: [],
    datasets: [
  
    ],
  };


  HolzData: ChartData<'line'> = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May'],
    datasets: [
      { label: 'Mobiles', data: [1000, 1200, 1050, 2000, 500], tension: 0.5 },
      { label: 'Laptop', data: [200, 100, 400, 50, 90], tension: 0.5 },
      { label: 'AC', data: [500, 400, 350, 450, 650], tension: 0.5 },
      { label: 'Headset', data: [1200, 1500, 1020, 1600, 900], tension: 0.5 },
    ],
  };
  chartHolzOptions: ChartOptions = {
    responsive: true,
    // backgroundColor: 'brown',
    plugins: {

      title: {
        display: false,
        text: 'Holzentnahme Übersicht',
        font: {
          size:  this.chartfontsize
        },
      },
      legend: {
        labels: {
          font: {
            size:  this.chartfontsize
          }

        }
      },

      tooltip: {
        bodyFont: {
          size:  this.chartfontsize
        },
        titleFont: {
          size:  this.chartfontsize
        }
      },
      /*  scales:{
          y: {
          ticks: {
        //    color: 'blue'
          }
          
        }
        },
        */
    },
    scales: {
      xAxes: {
        ticks: {
          font: {
            size:  this.chartfontsize
          }

        }
      }
    },
  };

  LineData: ChartData<'line'> = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May'],
    datasets: [
      { label: 'Mobiles', data: [1000, 1200, 1050, 2000, 500], tension: 0.5 },
      { label: 'Laptop', data: [200, 100, 400, 50, 90], tension: 0.5 },
      { label: 'AC', data: [500, 400, 350, 450, 650], tension: 0.5 },
      { label: 'Headset', data: [1200, 1500, 1020, 1600, 900], tension: 0.5 },
    ],
  };
  chartLineOptions: ChartOptions = {
    responsive: true,
    plugins: {

      title: {
        display: false,
        text: 'Tagschichten pro Jahr',
        font: {
          size:  this.chartfontsize
        },
      },
      legend: {
        labels: {
          font: {
           size:  this.chartfontsize
          }

        }
      },

      tooltip: {
        bodyFont: {
          size:  this.chartfontsize
        },
        titleFont: {
          size:  this.chartfontsize
        }
      },
      /*  scales:{
          y: {
          ticks: {
        //    color: 'blue'
          }
          
        }
        },
        */
    },
    scales: {
      xAxes: {
        ticks: {
          font: {
            size:  this.chartfontsize
          }

        }
      }
    },
  };

  chartLineVerlaufOptions: ChartOptions = {
    responsive: true,
    plugins: {

      title: {
        display: false,
        text: '[Holz / Tagschichten] über die Jahre',
    //    font: {
     //     size: 20
      //  },
      },
      legend: {
        labels: {
          font: {
            size:  this.chartfontsize
          }

        }
      },

      tooltip: {
        bodyFont: {
          size:  this.chartfontsize
        },
        titleFont: {
          size: this.chartfontsize
        }
      },
      /*  scales:{
          y: {
          ticks: {
        //    color: 'blue'
          }
          
        }
        },
        */
    },
    scales: {
      xAxes: {
        ticks: {
         font: {
            size:  this.chartfontsize
          }

        }
      }
    },
  };

  HolzzuTagData: ChartData<'line'> = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May'],
    datasets: [
      { label: 'Mobiles', data: [1000, 1200, 1050, 2000, 500], tension: 0.5 },
      { label: 'Laptop', data: [200, 100, 400, 50, 90], tension: 0.5 },
      { label: 'AC', data: [500, 400, 350, 450, 650], tension: 0.5 },
      { label: 'Headset', data: [1200, 1500, 1020, 1600, 900], tension: 0.5 },
    ],
  };
  chartHolz_zuTagOptions: ChartOptions = {
    responsive: true,
    backgroundColor: 'brown',
    plugins: {

      title: {
        display: false,
        text: 'Tagschichten',
       font: {
        size:  this.chartfontsize
       },
      },
      legend: {
        labels: {
          font: {
            size:  this.chartfontsize
          }

        }
      },
    
      tooltip: {
        bodyFont: {
          size:  this.chartfontsize
        },
        titleFont: {
          size:  this.chartfontsize
        },
      },
      /*  scales:{
          y: {
          ticks: {
        //    color: 'blue'
          }
          
        }
        },
        */
    },
    scales: {
      xAxes: {
        ticks: {
     //     font: {
      //      size: 16
       //   }

        }
      }
    },
  };
  public myPassword = "";
  public myRange=5;
  hidecode = false;
  hide = true;

  title = "KU-Schichten";

  KulturP: Kultur[];

  
  total;
  thomas_ts: string[];

  sum_vk_scheiter: number;
  sum_vk_ballen: number;
  sum_michi: number;
  sum_thomas: number;
  sum_joachim: number;
  sum_tobi: number;
  sum_robert: number;
  sum_christian: number;
  sum_josef: number;
  sum_luggi: number;
  sum_flori: number;
  sum_laurin: number;
  sum_linus: number;
  sum_maxi: number;
  sum_lisa: number;
  // TS ueber HZ einbringung
  sum_michi_hzeinbring: number;
  sum_thomas_hzeinbring: number;
  sum_joachim_hzeinbring: number;
  sum_tobi_hzeinbring: number;
  sum_robert_hzeinbring: number;
  sum_christian_hzeinbring: number;
  sum_josef_hzeinbring: number;
  sum_luggi_hzeinbring: number;
  sum_flori_hzeinbring: number;
  sum_laurin_hzeinbring: number;
  sum_linus_hzeinbring: number;
  sum_maxi_hzeinbring: number;
  sum_lisa_hzeinbring: number;
 // TS gesamt
 sum_TSmichi: number;
 sum_TSthomas: number;
 sum_TSjoachim: number;
 sum_TStobi: number;
 sum_TSrobert: number;
 sum_TSchristian: number;
 sum_TSjosef: number;
 sum_TSluggi: number;
 sum_TSflori: number;
 sum_TSlaurin: number;
 sum_TSlinus: number;
 sum_TSmaxi: number;
 sum_TSlisa: number;
  //Buendel
  sum_hbmichi: number;
  sum_hbthomas: number;
  sum_hbjoachim: number;
  sum_hbtobi: number;
  sum_hbrobert: number;
  sum_hbchristian: number;
  sum_hbjosef: number;
  sum_hbluggi: number;
  sum_hbflori: number;
  sum_hblaurin: number;
  sum_hblinus: number;
  sum_hbmaxi: number;
  sum_hblisa: number;
  //Scheiter
  sum_hsmichi: number;
  sum_hsthomas: number;
  sum_hsjoachim: number;
  sum_hstobi: number;
  sum_hsrobert: number;
  sum_hschristian: number;
  sum_hsjosef: number;
  sum_hsluggi: number;
  sum_hsflori: number;
  sum_hslaurin: number;
  sum_hslinus: number;
  sum_hsmaxi: number;
  sum_hslisa: number;
// sum Pfähl
  sum_hpmichi: number;
  sum_hpthomas: number;
  sum_hpjoachim: number;
  sum_hptobi: number;
  sum_hprobert: number;
  sum_hpchristian: number;
  sum_hpjosef: number;
  sum_hpluggi: number;
  sum_hpflori: number;
  sum_hplaurin: number;
  sum_hplinus: number;
  sum_hpmaxi: number;
  sum_hplisa: number;
  // Ster zu SRM
  fak_ster_zu_srm: number;
  fak_pfael_zu_srm: number;

  fak_holzein_tagschicht: number;
  sum_hmichi: number;
  sum_hthomas: number;
  sum_hjoachim: number;
  sum_htobi: number;
  sum_hrobert: number;
  sum_hchristian: number;
  sum_hjosef: number;
  sum_hluggi: number;
  sum_hflori: number;
  sum_hlaurin: number;
  sum_hlinus: number;
  sum_hmaxi: number;
  sum_hlisa: number;

  sum_gesamtholz: number;

  sum_gesamttagschicht: number;

  gesamt_tag_zu_holz: number;
  gesamt_holz_zu_tag: number;

  b_greenmichi: boolean;
  b_greenthomas: boolean;
  b_greenjoachim: boolean;
  b_greentobi: boolean;
  b_greenrobert: boolean;
  b_greenchristian: boolean;
  b_greenjosef: boolean;
  b_greenluggi: boolean;
  b_greenflori: boolean;
  b_greenlaurin: boolean;
  b_greenlinus: boolean;
  b_greenmaxi: boolean;
  b_greenlisa: boolean;

  saldoholz_michi: number;
  saldotag_michi: number;
  saldoholz_thomas: number;
  saldotag_thomas: number;
  saldoholz_joachim: number;
  saldotag_joachim: number;
  saldoholz_tobi: number;
  saldotag_tobi: number;
  saldoholz_robert: number;
  saldotag_robert: number;
  saldoholz_christian: number;
  saldotag_christian: number;
  saldoholz_josef: number;
  saldotag_josef: number;
  saldoholz_luggi: number;
  saldotag_luggi: number;
  saldoholz_flori: number;
  saldotag_flori: number;
  saldoholz_laurin: number;
  saldotag_laurin: number;
  saldoholz_linus: number;
  saldotag_linus: number;
  saldoholz_maxi: number;
  saldotag_maxi: number;
  saldoholz_lisa: number;
  saldotag_lisa: number;
  marvelHeroes;

  //  Kassenp: Array<KassenModel>;

  private value;

  displayedColumns: string[] = ["year", "michi", "thomas", "joachim", "tobi", "robert",
    "christian", "josef", "luggi", "flori", "laurin", "linus", "maxi", "lisa"];
  displC: string[] = ["michi", "thomas"];

  constructor(private Kultur: KUService) {
    // Chart.register(...registerables);
  }

  ngOnInit(): void {

    this.getKultur();
  
  



  }

  ngAfterViewInit() {

    // this.getChart();
  }
  getKultur(): void {


    let init: number;
    init = 0;
    /*
    this.PieChart = new Chart('pieChart',{
      type: 'pie',
      data:{
    labels:["Blue", "Green", "pink"],
    datasets: [{
      label: 'Vole No', 
      data:[101,100,102],
      backgroundColor:[
        'rgba(40,23,244,0.9)',
        'rgba(192,255,0,0.9)',
        'rgba(239,23,240,0.9)',
      ],
    
    }]
      },
      options:{
        title:{
          Text:"Bar Chart",
          display:true
        },
        scales:{
         // yAxes:[{
          //  ticks: {
         //  begineatZero:true
          //  }
         // }]
        }
      }
    })
    */

    this.fak_ster_zu_srm = (1 / 0.6);
    this.fak_pfael_zu_srm = (2 / 30);
    this.fak_holzein_tagschicht = 5;

    this.Kultur.getKultur()
      .subscribe((data) => {
        this.KulturP = data; console.log(this.KulturP);

        this.marvelHeroes = data.filter(function (hero) {
          return hero;
        });
    
        this.sum_vk_ballen = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.hz_ballen), init);

        this.sum_vk_scheiter = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.hz_scheiter), init);

        this.sum_michi = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.michi), init);

        this.sum_thomas = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.thomas), init);
        this.sum_joachim = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.joachim), init);
        this.sum_tobi = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.tobi), init);
        this.sum_robert = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.robert), init);
        this.sum_christian = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.christian), init);
        this.sum_josef = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.josef), init);
        this.sum_luggi = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.luggi), init);
        this.sum_flori = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.flori), init);
        this.sum_laurin = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.laurin), init);
        this.sum_linus = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.linus), init);
            this.sum_maxi = data.reduce<number>(
              (accumulator: number, currentValue) =>
                accumulator + Number(currentValue.maxi), init);

                this.sum_lisa = data.reduce<number>(
                  (accumulator: number, currentValue) =>
                    accumulator + Number(currentValue.lisa), init);
            // TS über HZ einbringung
        this.sum_michi_hzeinbring = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.michi_hzeinbring), init);
       

            this.sum_thomas_hzeinbring = data.reduce<number>(
              (accumulator: number, currentValue) =>
                accumulator + Number(currentValue.thomas_hzeinbring), init);
            this.sum_joachim_hzeinbring = data.reduce<number>(
              (accumulator: number, currentValue) =>
                accumulator + Number(currentValue.joachim_hzeinbring), init);
            this.sum_tobi_hzeinbring = data.reduce<number>(
              (accumulator: number, currentValue) =>
                accumulator + Number(currentValue.tobi_hzeinbring), init);
            this.sum_robert_hzeinbring = data.reduce<number>(
              (accumulator: number, currentValue) =>
                accumulator + Number(currentValue.robert_hzeinbring), init);
            this.sum_christian_hzeinbring = data.reduce<number>(
              (accumulator: number, currentValue) =>
                accumulator + Number(currentValue.christian_hzeinbring), init);
            this.sum_josef_hzeinbring = data.reduce<number>(
              (accumulator: number, currentValue) =>
                accumulator + Number(currentValue.josef_hzeinbring), init);
            this.sum_luggi_hzeinbring = data.reduce<number>(
              (accumulator: number, currentValue) =>
                accumulator + Number(currentValue.luggi_hzeinbring), init);
            this.sum_flori_hzeinbring = data.reduce<number>(
              (accumulator: number, currentValue) =>
                accumulator + Number(currentValue.flori_hzeinbring), init);
            this.sum_laurin_hzeinbring = data.reduce<number>(
              (accumulator: number, currentValue) =>
                accumulator + Number(currentValue.laurin_hzeinbring), init);
            this.sum_linus_hzeinbring = data.reduce<number>(
              (accumulator: number, currentValue) =>
                accumulator + Number(currentValue.linus_hzeinbring), init);
                this.sum_maxi_hzeinbring = data.reduce<number>(
                  (accumulator: number, currentValue) =>
                    accumulator + Number(currentValue.maxi_hzeinbring), init);
                    this.sum_lisa_hzeinbring = data.reduce<number>(
                      (accumulator: number, currentValue) =>
                        accumulator + Number(currentValue.lisa_hzeinbring), init);
                // TS mit HZ einbringung

                this.sum_TSmichi = (this.sum_michi) +( this.sum_michi_hzeinbring/this.fak_holzein_tagschicht);
            console.log( "Sum sum_TSmichi:" +this.sum_TSmichi);
                this.sum_TSthomas = (this.sum_thomas) +( this.sum_thomas_hzeinbring/this.fak_holzein_tagschicht);
                this.sum_TStobi = (this.sum_tobi) +( this.sum_tobi_hzeinbring/this.fak_holzein_tagschicht);
                this.sum_TSjoachim = (this.sum_joachim) +( this.sum_joachim_hzeinbring/this.fak_holzein_tagschicht);
                this.sum_TSchristian = (this.sum_christian) +( this.sum_christian_hzeinbring/this.fak_holzein_tagschicht);
                this.sum_TSrobert = (this.sum_robert) +( this.sum_robert_hzeinbring/this.fak_holzein_tagschicht);
                this.sum_TSjosef = (this.sum_josef) +( this.sum_josef_hzeinbring/this.fak_holzein_tagschicht);
                this.sum_TSluggi = (this.sum_luggi) +( this.sum_luggi_hzeinbring/this.fak_holzein_tagschicht);
                this.sum_TSlaurin = (this.sum_laurin) +( this.sum_laurin_hzeinbring/this.fak_holzein_tagschicht);
                this.sum_TSlinus = (this.sum_linus) +( this.sum_linus_hzeinbring/this.fak_holzein_tagschicht);
                this.sum_TSflori = (this.sum_flori) +( this.sum_flori_hzeinbring/this.fak_holzein_tagschicht);
                this.sum_TSmaxi = (this.sum_maxi) +( this.sum_maxi_hzeinbring/this.fak_holzein_tagschicht);
                this.sum_TSlisa = (this.sum_lisa) +( this.sum_lisa_hzeinbring/this.fak_holzein_tagschicht);

                // Scheiter
        this.sum_hsmichi = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.hsch_michi), init);

            console.log( "Sum sum_hsmichi:" +this.sum_hsmichi);
        this.sum_hbmichi = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.hb_michi), init);

            console.log( "Sum sum_hbmichi:" +this.sum_hbmichi);
           
            this.sum_hpmichi = data.reduce<number>(
              (accumulator: number, currentValue) =>
                accumulator + Number(currentValue.hp_michi), init);
           
              console.log( "Sum sum_hpmichi:" +this.sum_hpmichi);
       
                this.sum_hsthomas = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.hsch_thomas), init);

        this.sum_hbthomas = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.hb_thomas), init);

            
        this.sum_hpthomas = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.hp_thomas), init);

        this.sum_hbjoachim = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.hb_joachim), init);

        this.sum_hsjoachim = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.hsch_joachim), init);
        this.sum_hpjoachim = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.hp_joachim), init);

            console.log('HP Joachim' + this.sum_hpjoachim);
          
        this.sum_hbtobi = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.hb_tobi), init);
        this.sum_hstobi = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.hsch_tobi), init);
            this.sum_hptobi = data.reduce<number>(
              (accumulator: number, currentValue) =>
                accumulator + Number(currentValue.hp_tobi), init);
        this.sum_hsrobert = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.hsch_robert), init);
        this.sum_hbrobert = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.hb_robert), init);
            this.sum_hprobert = data.reduce<number>(
              (accumulator: number, currentValue) =>
                accumulator + Number(currentValue.hp_robert), init);
        this.sum_hschristian = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.hsch_christian), init);
        this.sum_hbchristian = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.hb_christian), init);
            this.sum_hpchristian = data.reduce<number>(
              (accumulator: number, currentValue) =>
                accumulator + Number(currentValue.hp_christian), init);
        this.sum_hsjosef = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.hsch_josef), init);
        this.sum_hbjosef = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.hb_josef), init);
            this.sum_hpjosef = data.reduce<number>(
              (accumulator: number, currentValue) =>
                accumulator + Number(currentValue.hp_josef), init);
        this.sum_hsluggi = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.hsch_luggi), init);
        this.sum_hbluggi = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.hb_luggi), init);
            this.sum_hpluggi = data.reduce<number>(
              (accumulator: number, currentValue) =>
                accumulator + Number(currentValue.hp_luggi), init);
        this.sum_hbflori = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.hb_flori), init);
        this.sum_hsflori = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.hsch_flori), init);
            this.sum_hpflori = data.reduce<number>(
              (accumulator: number, currentValue) =>
                accumulator + Number(currentValue.hp_flori), init);
        this.sum_hblaurin = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.hb_laurin), init);
        this.sum_hslaurin = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.hsch_laurin), init);
            this.sum_hplaurin = data.reduce<number>(
              (accumulator: number, currentValue) =>
                accumulator + Number(currentValue.hp_laurin), init);
        this.sum_hblinus = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.hb_linus), init);
        this.sum_hslinus = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.hsch_linus), init);
            this.sum_hplinus = data.reduce<number>(
              (accumulator: number, currentValue) =>
                accumulator + Number(currentValue.hp_linus), init);

        this.sum_hbmaxi = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.hb_maxi), init);
        this.sum_hsmaxi = data.reduce<number>(
          (accumulator: number, currentValue) =>
            accumulator + Number(currentValue.hsch_maxi), init);
            this.sum_hpmaxi = data.reduce<number>(
              (accumulator: number, currentValue) =>
                accumulator + Number(currentValue.hp_maxi), init);
            this.sum_hblisa = data.reduce<number>(
              (accumulator: number, currentValue) =>
                accumulator + Number(currentValue.hb_lisa), init);
            this.sum_hslisa = data.reduce<number>(
              (accumulator: number, currentValue) =>
                accumulator + Number(currentValue.hsch_lisa), init);
                this.sum_hplisa = data.reduce<number>(
                  (accumulator: number, currentValue) =>
                    accumulator + Number(currentValue.hp_lisa), init);

      
        
             

        this.sum_hmichi = (this.sum_hbmichi * this.fak_ster_zu_srm) + (this.sum_hpmichi * this.fak_pfael_zu_srm) + this.sum_hsmichi;
        console.log('HP sum_hmichi' + this.sum_hmichi);
      
        this.sum_hthomas = (this.sum_hbthomas * this.fak_ster_zu_srm) + (this.sum_hpthomas * this.fak_pfael_zu_srm)  + this.sum_hsthomas;
        this.sum_hjoachim = (this.sum_hbjoachim * this.fak_ster_zu_srm) + (this.sum_hpjoachim * this.fak_pfael_zu_srm) + this.sum_hsjoachim;
        this.sum_htobi = (this.sum_hbtobi * this.fak_ster_zu_srm) + (this.sum_hptobi * this.fak_pfael_zu_srm) + this.sum_hstobi;
        this.sum_hrobert = (this.sum_hbrobert * this.fak_ster_zu_srm) + (this.sum_hprobert * this.fak_pfael_zu_srm) + this.sum_hsrobert;
        this.sum_hchristian = (this.sum_hbchristian * this.fak_ster_zu_srm) + (this.sum_hpchristian * this.fak_pfael_zu_srm) + this.sum_hschristian;

        this.sum_hjosef = (this.sum_hbjosef * this.fak_ster_zu_srm) + (this.sum_hpjosef * this.fak_pfael_zu_srm) + this.sum_hsjosef;
        this.sum_hluggi = (this.sum_hbluggi * this.fak_ster_zu_srm) + (this.sum_hpluggi * this.fak_pfael_zu_srm) + this.sum_hsluggi;
        this.sum_hflori = (this.sum_hbflori * this.fak_ster_zu_srm) +  (this.sum_hpflori * this.fak_pfael_zu_srm) +this.sum_hsflori;
        this.sum_hlaurin = (this.sum_hblaurin * this.fak_ster_zu_srm)+ (this.sum_hplaurin * this.fak_pfael_zu_srm)  + this.sum_hslaurin;
        this.sum_hlinus = (this.sum_hblinus * this.fak_ster_zu_srm) + (this.sum_hplinus * this.fak_pfael_zu_srm) + this.sum_hslinus;
        this.sum_hmaxi = (this.sum_hbmaxi * this.fak_ster_zu_srm) + (this.sum_hpmaxi * this.fak_pfael_zu_srm) + this.sum_hsmaxi;
        this.sum_hlisa = (this.sum_hblisa * this.fak_ster_zu_srm) + (this.sum_hplisa * this.fak_pfael_zu_srm) + this.sum_hslisa;
        /*
        this.sum_hthomas=data.reduce<number>(
          (accumulator: number, currentValue) =>  
        accumulator + Number(currentValue.hthomas), init);
        this.sum_hjoachim=data.reduce<number>(
          (accumulator: number, currentValue) =>  
        accumulator + Number(currentValue.hjoachim), init);
        this.sum_htobi=data.reduce<number>(
          (accumulator: number, currentValue) =>  
        accumulator + Number(currentValue.htobi), init);
        this.sum_hrobert=data.reduce<number>(
          (accumulator: number, currentValue) =>  
        accumulator + Number(currentValue.hrobert), init);
        this.sum_hchristian=data.reduce<number>(
          (accumulator: number, currentValue) =>  
        accumulator + Number(currentValue.hchristian), init);
        this.sum_hjosef=data.reduce<number>(
          (accumulator: number, currentValue) =>  
        accumulator + Number(currentValue.hjosef), init);
        this.sum_hluggi=data.reduce<number>(
          (accumulator: number, currentValue) =>  
        accumulator + Number(currentValue.hluggi), init);
        this.sum_hflori=data.reduce<number>(
          (accumulator: number, currentValue) =>  
        accumulator + Number(currentValue.hflori), init);
        this.sum_hlaurin=data.reduce<number>(
          (accumulator: number, currentValue) =>  
        accumulator + Number(currentValue.hlaurin), init);
        this.sum_hlinus=data.reduce<number>(
          (accumulator: number, currentValue) =>  
        accumulator + Number(currentValue.hlinus), init);
    */
        this.sum_gesamtholz = this.sum_hmichi + this.sum_hthomas + this.sum_hjoachim +
          this.sum_htobi + this.sum_hrobert + this.sum_hchristian + this.sum_hjosef +
          this.sum_hluggi + this.sum_hflori + this.sum_hlaurin + this.sum_hlinus + this.sum_hmaxi 
          +this.sum_hlisa;

        this.sum_gesamttagschicht = this.sum_TSmichi + this.sum_TSthomas + this.sum_TSjoachim +
          this.sum_TStobi + this.sum_TSrobert + this.sum_TSchristian + this.sum_TSjosef +
          this.sum_TSluggi + this.sum_TSflori + this.sum_TSlaurin + this.sum_TSlinus + this.sum_TSmaxi+ 
          this.sum_TSlisa;

        this.gesamt_tag_zu_holz = this.sum_gesamttagschicht / this.sum_gesamtholz;

        this.gesamt_holz_zu_tag = this.sum_gesamtholz / this.sum_gesamttagschicht;

        if (this.sum_TSmichi / this.sum_hmichi < this.gesamt_tag_zu_holz) {
          this.b_greenmichi = false;
        }
        else {
          this.b_greenmichi = true;
        }
        if (this.sum_TSthomas / this.sum_hthomas < this.gesamt_tag_zu_holz) {
          this.b_greenthomas = false;
        }
        else {
          this.b_greenthomas = true;
        }
        if (this.sum_TSjoachim / this.sum_hjoachim < this.gesamt_tag_zu_holz) {
          this.b_greenjoachim = false;
        }
        else {
          this.b_greenjoachim = true;
        }
        if (this.sum_TStobi / this.sum_htobi < this.gesamt_tag_zu_holz) {
          this.b_greentobi = false;
        }
        else {
          this.b_greentobi = true;
        }
        if (this.sum_TSrobert / this.sum_hrobert < this.gesamt_tag_zu_holz) {
          this.b_greenrobert = false;
        }
        else {
          this.b_greenrobert = true;
        }
        if (this.sum_TSchristian / this.sum_hchristian < this.gesamt_tag_zu_holz) {
          this.b_greenchristian = false;
        }
        else {
          this.b_greenchristian = true;
        }
        if (this.sum_TSjosef / this.sum_hjosef < this.gesamt_tag_zu_holz) {
          this.b_greenjosef = false;
        }
        else {
          this.b_greenjosef = true;
        }
        if (this.sum_TSluggi / this.sum_hluggi < this.gesamt_tag_zu_holz) {
          this.b_greenluggi = false;
        }
        else {
          this.b_greenluggi = true;
        }
        if (this.sum_TSflori / this.sum_hflori < this.gesamt_tag_zu_holz) {
          this.b_greenflori = false;
        }
        else {
          this.b_greenflori = true;
        }
        if (this.sum_TSlaurin / this.sum_hlaurin < this.gesamt_tag_zu_holz) {
          this.b_greenlaurin = false;
        }
        else {
          this.b_greenlaurin = true;
        }
        if (this.sum_TSlinus / this.sum_hlinus < this.gesamt_tag_zu_holz) {
          this.b_greenlinus = false;
        }
        else {
          this.b_greenlinus = true;
        }

        if (this.sum_TSmaxi / this.sum_hmaxi < this.gesamt_tag_zu_holz) {
          this.b_greenmaxi = false;
        }
        else {
          this.b_greenmaxi = true;
        }

        if (this.sum_TSlisa / this.sum_hlisa < this.gesamt_tag_zu_holz) {
          this.b_greenlisa = false;
        }
        else {
          this.b_greenlisa = true;
        }
var test;
test= ((this.sum_hthomas*this.sum_gesamttagschicht) - (this.sum_gesamtholz* this.sum_TSthomas))/(this.sum_TSthomas+this.sum_gesamttagschicht);

//alte Formel
       // this.saldoholz_michi = (this.gesamt_holz_zu_tag * this.sum_michi) - (this.sum_hmichi);
       this.saldoholz_michi = (-1) * ((this.sum_hmichi*this.sum_gesamttagschicht) - (this.sum_gesamtholz* this.sum_TSmichi))/(this.sum_TSmichi+this.sum_gesamttagschicht);
       console.log('HP saldoholz_michi' + this.saldoholz_michi);
  
  
       this.saldoholz_thomas = (-1) * ((this.sum_hthomas*this.sum_gesamttagschicht) - (this.sum_gesamtholz* this.sum_TSthomas))/(this.sum_TSthomas+this.sum_gesamttagschicht);

   
       this.saldoholz_joachim = (-1) * ((this.sum_hjoachim*this.sum_gesamttagschicht) - (this.sum_gesamtholz* this.sum_TSjoachim))/(this.sum_TSjoachim+this.sum_gesamttagschicht);


        this.saldoholz_tobi = (-1) * ((this.sum_htobi*this.sum_gesamttagschicht) - (this.sum_gesamtholz* this.sum_TStobi))/(this.sum_TStobi+this.sum_gesamttagschicht);
        this.saldoholz_robert =(-1) * ((this.sum_hrobert*this.sum_gesamttagschicht) - (this.sum_gesamtholz* this.sum_TSrobert))/(this.sum_TSrobert+this.sum_gesamttagschicht);
        this.saldoholz_christian =(-1) *  ((this.sum_hchristian*this.sum_gesamttagschicht) - (this.sum_gesamtholz* this.sum_TSchristian))/(this.sum_TSchristian+this.sum_gesamttagschicht);
        this.saldoholz_josef = (-1) * ((this.sum_hjosef*this.sum_gesamttagschicht) - (this.sum_gesamtholz* this.sum_TSjosef))/(this.sum_TSjosef+this.sum_gesamttagschicht);
        this.saldoholz_luggi = (-1) * ((this.sum_hluggi*this.sum_gesamttagschicht) - (this.sum_gesamtholz* this.sum_TSluggi))/(this.sum_TSluggi+this.sum_gesamttagschicht);
        this.saldoholz_flori = (-1) * ((this.sum_hflori*this.sum_gesamttagschicht) - (this.sum_gesamtholz* this.sum_TSflori))/(this.sum_TSflori+this.sum_gesamttagschicht);
        this.saldoholz_laurin =(-1) *  ((this.sum_hlaurin*this.sum_gesamttagschicht) - (this.sum_gesamtholz* this.sum_TSlaurin))/(this.sum_TSlaurin+this.sum_gesamttagschicht);
        this.saldoholz_linus = (-1) * ((this.sum_hlinus*this.sum_gesamttagschicht) - (this.sum_gesamtholz* this.sum_TSlinus))/(this.sum_TSlinus+this.sum_gesamttagschicht);
        this.saldoholz_maxi = (-1) * ((this.sum_hmaxi*this.sum_gesamttagschicht) - (this.sum_gesamtholz* this.sum_TSmaxi))/(this.sum_TSmaxi+this.sum_gesamttagschicht);
        this.saldoholz_lisa = (-1) * ((this.sum_hlisa*this.sum_gesamttagschicht) - (this.sum_gesamtholz* this.sum_TSlisa))/(this.sum_TSlisa+this.sum_gesamttagschicht);


        var tagtest;
       
        tagtest= ((this.sum_TSthomas*this.sum_gesamtholz) - (this.sum_gesamttagschicht* this.sum_hthomas))/
        (this.sum_hthomas+this.sum_gesamtholz);

//alte Fromel mit aktuellem Schnitt
//this.saldotag_michi = (-1) * ((this.gesamt_tag_zu_holz * this.sum_hmichi) - (this.sum_michi));
     
// neue mit dann neume Schnitt
        this.saldotag_michi = ((this.sum_TSmichi*this.sum_gesamtholz) - (this.sum_gesamttagschicht* this.sum_hmichi))/
        (this.sum_hmichi+this.sum_gesamtholz);

        console.log('HP saldotag_michi' + this.saldotag_michi);
        this.saldotag_thomas = ((this.sum_TSthomas*this.sum_gesamtholz) - (this.sum_gesamttagschicht* this.sum_hthomas))/
        (this.sum_hthomas+this.sum_gesamtholz);
      
      
        this.saldotag_joachim = ((this.sum_TSjoachim*this.sum_gesamtholz) - (this.sum_gesamttagschicht* this.sum_hjoachim))/
        (this.sum_hjoachim+this.sum_gesamtholz);
        this.saldotag_tobi = ((this.sum_TStobi*this.sum_gesamtholz) - (this.sum_gesamttagschicht* this.sum_htobi))/
        (this.sum_htobi+this.sum_gesamtholz);
        this.saldotag_robert = ((this.sum_TSrobert*this.sum_gesamtholz) - (this.sum_gesamttagschicht* this.sum_hrobert))/
        (this.sum_hrobert+this.sum_gesamtholz);
        this.saldotag_christian = ((this.sum_TSchristian*this.sum_gesamtholz) - (this.sum_gesamttagschicht* this.sum_hchristian))/
        (this.sum_hchristian+this.sum_gesamtholz);
        this.saldotag_josef = ((this.sum_TSjosef*this.sum_gesamtholz) - (this.sum_gesamttagschicht* this.sum_hjosef))/
        (this.sum_hjosef+this.sum_gesamtholz);
        this.saldotag_luggi = ((this.sum_TSluggi*this.sum_gesamtholz) - (this.sum_gesamttagschicht* this.sum_hluggi))/
        (this.sum_hluggi+this.sum_gesamtholz);
        this.saldotag_flori = ((this.sum_TSflori*this.sum_gesamtholz) - (this.sum_gesamttagschicht* this.sum_hflori))/
        (this.sum_hflori+this.sum_gesamtholz);
        this.saldotag_laurin = ((this.sum_TSlaurin*this.sum_gesamtholz) - (this.sum_gesamttagschicht* this.sum_hlaurin))/
        (this.sum_hlaurin+this.sum_gesamtholz);
        this.saldotag_linus = ((this.sum_TSlinus*this.sum_gesamtholz) - (this.sum_gesamttagschicht* this.sum_hlinus))/
        (this.sum_hlinus+this.sum_gesamtholz);
        this.saldotag_maxi = ((this.sum_TSmaxi*this.sum_gesamtholz) - (this.sum_gesamttagschicht* this.sum_hmaxi))/
        (this.sum_hmaxi+this.sum_gesamtholz);
        this.saldotag_lisa = ((this.sum_TSlisa*this.sum_gesamtholz) - (this.sum_gesamttagschicht* this.sum_hlisa))/
        (this.sum_hlisa+this.sum_gesamtholz);


        this.plusminusData.datasets = [
          {
            label: '+/- Holz', data: [this.saldoholz_michi,
            this.saldoholz_thomas, this.saldoholz_joachim, this.saldoholz_tobi, this.saldoholz_robert,
            this.saldoholz_christian, this.saldoholz_josef, this.saldoholz_luggi, this.saldoholz_flori,
            this.saldoholz_laurin, this.saldoholz_linus, this.saldoholz_maxi, this.saldoholz_lisa], backgroundColor: 'brown'
          
          },
          {
            label: '+/- Tagschichten', data: [this.saldotag_michi,
            this.saldotag_thomas, this.saldotag_joachim, this.saldotag_tobi, this.saldotag_robert,
            this.saldotag_christian, this.saldotag_josef, this.saldotag_luggi, this.saldotag_flori,
            this.saldotag_laurin, this.saldotag_linus, this.saldotag_maxi, this.saldotag_lisa], backgroundColor: 'blue'
          },
        ];


        this.plusminusData.labels =  [ 'michi', 'thomas', 'joachim', 'tobi', 'robert',
          'christian', 'josef', 'luggi', 'flori', 'laurin', 'linus', 'maxi', 'lisa'];//this.TagschichtenData.labels;
     //   this.TagschichtenData.labels = this.plusminusData.labels;
/*
if (this.saldoholz_michi<0)
{
  this.plusminusData.datasets[0].borderColor='rgba(255,0,0,0.2)';
}
else{
  this.plusminusData.datasets[0].borderColor='rgba(0,255,0,0.2)';
}
if (this.saldoholz_joachim<0)
  {
    this.plusminusData.datasets[2].borderColor='rgba(255,0,0,0.2)';
  }
  else{
    this.plusminusData.datasets[2].borderColor='rgba(0,255,0,0.2)';
  }
    */
// Tagschichten mit HZ Einbringung
  // Holz scheiter und buendel in SRM
  for (let i = 0; i < 13; i++) {
    this.marvelHeroes[i].TSmichi = this.marvelHeroes[i].michi + 
    (this.marvelHeroes[i].michi_hzeinbring / this.fak_holzein_tagschicht);
    this.marvelHeroes[i].TSthomas = this.marvelHeroes[i].thomas + (this.marvelHeroes[i].thomas_hzeinbring / this.fak_holzein_tagschicht);
    this.marvelHeroes[i].TStobi = this.marvelHeroes[i].tobi + (this.marvelHeroes[i].tobi_hzeinbring / this.fak_holzein_tagschicht);
    this.marvelHeroes[i].TSjoachim = this.marvelHeroes[i].joachim + (this.marvelHeroes[i].joachim_hzeinbring / this.fak_holzein_tagschicht);
    this.marvelHeroes[i].TSchristian = this.marvelHeroes[i].christian + (this.marvelHeroes[i].christian_hzeinbring / this.fak_holzein_tagschicht);
    this.marvelHeroes[i].TSjosef = this.marvelHeroes[i].josef + (this.marvelHeroes[i].josef_hzeinbring / this.fak_holzein_tagschicht);
    this.marvelHeroes[i].TSluggi = this.marvelHeroes[i].luggi + (this.marvelHeroes[i].luggi_hzeinbring / this.fak_holzein_tagschicht);
    this.marvelHeroes[i].TSflori = this.marvelHeroes[i].flori + (this.marvelHeroes[i].flori_hzeinbring / this.fak_holzein_tagschicht);
    this.marvelHeroes[i].TSrobert = this.marvelHeroes[i].robert + (this.marvelHeroes[i].robert_hzeinbring / this.fak_holzein_tagschicht);
    this.marvelHeroes[i].TSlinus = this.marvelHeroes[i].linus + (this.marvelHeroes[i].linus_hzeinbring / this.fak_holzein_tagschicht);
    this.marvelHeroes[i].TSlaurin = this.marvelHeroes[i].laurin + (this.marvelHeroes[i].laurin_hzeinbring / this.fak_holzein_tagschicht);
    this.marvelHeroes[i].TSmaxi = this.marvelHeroes[i].maxi + (this.marvelHeroes[i].maxi_hzeinbring / this.fak_holzein_tagschicht);
    this.marvelHeroes[i].TSlisa = this.marvelHeroes[i].lisa + (this.marvelHeroes[i].lisa_hzeinbring / this.fak_holzein_tagschicht);
 
   
  }

        // Holz scheiter und buendel in SRM
        for (let i = 0; i < 13; i++) {
          this.marvelHeroes[i].h_michi = this.marvelHeroes[i].hsch_michi + 
          (this.marvelHeroes[i].hb_michi * this.fak_ster_zu_srm) + 
          (this.marvelHeroes[i].hp_michi * this.fak_pfael_zu_srm);
          this.marvelHeroes[i].h_thomas = this.marvelHeroes[i].hsch_thomas + 
          (this.marvelHeroes[i].hb_thomas * this.fak_ster_zu_srm)+
          (this.marvelHeroes[i].hp_thomas * this.fak_pfael_zu_srm);
  
          this.marvelHeroes[i].h_tobi = this.marvelHeroes[i].hsch_tobi + 
          (this.marvelHeroes[i].hb_tobi * this.fak_ster_zu_srm) +
          (this.marvelHeroes[i].hp_tobi * this.fak_pfael_zu_srm);

          this.marvelHeroes[i].h_joachim = this.marvelHeroes[i].hsch_joachim + 
          (this.marvelHeroes[i].hb_joachim * this.fak_ster_zu_srm)
          +(this.marvelHeroes[i].hp_joachim * this.fak_pfael_zu_srm);

          this.marvelHeroes[i].h_christian = this.marvelHeroes[i].hsch_christian + 
          (this.marvelHeroes[i].hb_christian * this.fak_ster_zu_srm) +
          (this.marvelHeroes[i].hp_christian * this.fak_pfael_zu_srm);

          this.marvelHeroes[i].h_josef = this.marvelHeroes[i].hsch_josef + 
          (this.marvelHeroes[i].hb_josef * this.fak_ster_zu_srm) +
          (this.marvelHeroes[i].hp_josef * this.fak_pfael_zu_srm);
          this.marvelHeroes[i].h_luggi = this.marvelHeroes[i].hsch_luggi + 
          (this.marvelHeroes[i].hb_luggi * this.fak_ster_zu_srm) +
          (this.marvelHeroes[i].hp_luggi * this.fak_pfael_zu_srm);
          this.marvelHeroes[i].h_flori = this.marvelHeroes[i].hsch_flori +
           (this.marvelHeroes[i].hb_flori * this.fak_ster_zu_srm) +
           (this.marvelHeroes[i].hp_flori * this.fak_pfael_zu_srm);
          this.marvelHeroes[i].h_robert = this.marvelHeroes[i].hsch_robert + 
          (this.marvelHeroes[i].hb_robert * this.fak_ster_zu_srm) + 
          (this.marvelHeroes[i].hp_robert * this.fak_pfael_zu_srm);
        
         
          this.marvelHeroes[i].h_laurin = this.marvelHeroes[i].hsch_laurin + 
          (this.marvelHeroes[i].hb_laurin * this.fak_ster_zu_srm) +
          (this.marvelHeroes[i].hp_laurin * this.fak_pfael_zu_srm);
          this.marvelHeroes[i].h_linus = this.marvelHeroes[i].hsch_linus + 
          (this.marvelHeroes[i].hb_linus * this.fak_ster_zu_srm) +
          (this.marvelHeroes[i].hp_linus * this.fak_pfael_zu_srm);
          this.marvelHeroes[i].h_maxi = this.marvelHeroes[i].hsch_maxi + 
          (this.marvelHeroes[i].hb_maxi * this.fak_ster_zu_srm) + 
          (this.marvelHeroes[i].hp_maxi * this.fak_pfael_zu_srm);
          this.marvelHeroes[i].h_lisa = this.marvelHeroes[i].hsch_lisa + 
          (this.marvelHeroes[i].hb_lisa * this.fak_ster_zu_srm) +
          (this.marvelHeroes[i].hp_lisa * this.fak_pfael_zu_srm);

        }

         this.LineData.labels = ['2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023','2024', '2025', '2026'];
        this.LineData.datasets = [
          {
            label: 'Thomas', data: [this.marvelHeroes[0].TSthomas, this.marvelHeroes[1].TSthomas, this.marvelHeroes[2].TSthomas,
            this.marvelHeroes[3].TS_thomas, this.marvelHeroes[4].TSthomas, this.marvelHeroes[5].TSthomas, this.marvelHeroes[6].TSthomas,
            this.marvelHeroes[7].TSthomas, this.marvelHeroes[8].TSthomas, this.marvelHeroes[9].TSthomas, this.marvelHeroes[10].TSthomas, this.marvelHeroes[11].TSthomas,
          this.marvelHeroes[12].TSthomas], tension: 0.5
          },
          {
            label: 'Michi', data: [this.marvelHeroes[0].TSmichi, this.marvelHeroes[1].TSmichi, this.marvelHeroes[2].TSmichi,
            this.marvelHeroes[3].TSmichi, this.marvelHeroes[4].TSmichi, this.marvelHeroes[5].TSmichi, this.marvelHeroes[6].TSmichi,
            this.marvelHeroes[7].TSmichi, this.marvelHeroes[8].TSmichi, this.marvelHeroes[9].TSmichi,this.marvelHeroes[10].TSmichi, this.marvelHeroes[11].TSmichi,
          this.marvelHeroes[12].TSmichi], tension: 0.5
          },
          {
            label: 'Tobi', data: [this.marvelHeroes[0].TStobi, this.marvelHeroes[1].TStobi, this.marvelHeroes[2].TStobi,
            this.marvelHeroes[3].TStobi, this.marvelHeroes[4].TStobi, this.marvelHeroes[5].TStobi, this.marvelHeroes[6].TStobi,
            this.marvelHeroes[7].TStobi, this.marvelHeroes[8].TStobi, this.marvelHeroes[9].TStobi, this.marvelHeroes[10].TStobi, this.marvelHeroes[11].TStobi,
             this.marvelHeroes[12].TStobi], tension: 0.5
          },
          {
            label: 'Joachim', data: [this.marvelHeroes[0].TSjoachim, this.marvelHeroes[1].TSjoachim, this.marvelHeroes[2].TSjoachim,
            this.marvelHeroes[3].TSjoachim, this.marvelHeroes[4].TSjoachim, this.marvelHeroes[5].TSjoachim, this.marvelHeroes[6].TSjoachim,
            this.marvelHeroes[7].TSjoachim, this.marvelHeroes[8].TSjoachim, this.marvelHeroes[9].TSjoachim,  this.marvelHeroes[10].TSjoachim,  this.marvelHeroes[11].TSjoachim,
          this.marvelHeroes[12].TSjoachim],tension: 0.5
          },
          {
            label: 'Christian', data: [this.marvelHeroes[0].TSchristian, this.marvelHeroes[1].TSchristian, this.marvelHeroes[2].TSchristian,
            this.marvelHeroes[3].TSchristian, this.marvelHeroes[4].TSchristian, this.marvelHeroes[5].TSchristian, this.marvelHeroes[6].TSchristian,
            this.marvelHeroes[7].TSchristian, this.marvelHeroes[8].TSchristian, this.marvelHeroes[9].TSchristian,this.marvelHeroes[10].TSchristian, this.marvelHeroes[11].TSchristian,
          this.marvelHeroes[12].TSchristian],  tension: 0.5
          },
          {
            label: 'Josef', data: [this.marvelHeroes[0].TSjosef, this.marvelHeroes[1].TSjosef, this.marvelHeroes[2].TSjosef,
            this.marvelHeroes[3].TSjosef, this.marvelHeroes[4].TSjosef, this.marvelHeroes[5].TSjosef, this.marvelHeroes[6].TSjosef,
            this.marvelHeroes[7].TSjosef, this.marvelHeroes[8].TSjosef, this.marvelHeroes[9].TSjosef, this.marvelHeroes[10].TSjosef, this.marvelHeroes[11].TSjosef,
          this.marvelHeroes[12].TSjosef], tension: 0.5
          },
          {
            label: 'Luggi', data: [this.marvelHeroes[0].TSluggi, this.marvelHeroes[1].TSluggi, this.marvelHeroes[2].TSluggi,
            this.marvelHeroes[3].TSluggi, this.marvelHeroes[4].TSluggi, this.marvelHeroes[5].TSluggi, this.marvelHeroes[6].TSluggi,
            this.marvelHeroes[7].TSluggi, this.marvelHeroes[8].TSluggi, this.marvelHeroes[9].TSluggi, this.marvelHeroes[10].TSluggi, this.marvelHeroes[11].TSluggi,
          this.marvelHeroes[12].TSluggi], tension: 0.5
          },
          {
            label: 'Flori', data: [this.marvelHeroes[0].TSflori, this.marvelHeroes[1].TSflori, this.marvelHeroes[2].TSflori,
            this.marvelHeroes[3].TSflori, this.marvelHeroes[4].TSflori, this.marvelHeroes[5].TSflori, this.marvelHeroes[6].TSflori,
            this.marvelHeroes[7].TSflori, this.marvelHeroes[8].TSflori, this.marvelHeroes[9].TSflori,this.marvelHeroes[10].TSflori, this.marvelHeroes[11].TSflori,
           this.marvelHeroes[12].TSflori], tension: 0.5
          },
          {
            label: 'Laurin', data: [this.marvelHeroes[0].TSlaurin, this.marvelHeroes[1].TSlaurin, this.marvelHeroes[2].TSlaurin,
            this.marvelHeroes[3].TSlaurin, this.marvelHeroes[4].TSlaurin, this.marvelHeroes[5].TSlaurin, this.marvelHeroes[6].TSlaurin,
            this.marvelHeroes[7].TSlaurin, this.marvelHeroes[8].TSlaurin, this.marvelHeroes[9].TSlaurin, this.marvelHeroes[10].TSlaurin, this.marvelHeroes[11].TSlaurin,
          this.marvelHeroes[12].TSlaurin], tension: 0.5
          },
          {
            label: 'Linus', data: [this.marvelHeroes[0].TSlinus, this.marvelHeroes[1].TSlinus, this.marvelHeroes[2].TSlinus,
            this.marvelHeroes[3].TSlinus, this.marvelHeroes[4].TSlinus, this.marvelHeroes[5].TSlinus, this.marvelHeroes[6].TSlinus,
            this.marvelHeroes[7].TSlinus, this.marvelHeroes[8].TSlinus, this.marvelHeroes[9].TSlinus, this.marvelHeroes[10].TSlinus, this.marvelHeroes[11].TSlinus,
          this.marvelHeroes[12].TSlinus], tension: 0.5
          },  
          {
            label: 'maxi', data: [this.marvelHeroes[0].TSmaxi, this.marvelHeroes[1].TSmaxi, this.marvelHeroes[2].TSmaxi,
            this.marvelHeroes[3].TSmaxi, this.marvelHeroes[4].TSmaxi, this.marvelHeroes[5].TSmaxi, this.marvelHeroes[6].TSmaxi,
            this.marvelHeroes[7].TSmaxi, this.marvelHeroes[8].TSmaxi, this.marvelHeroes[9].TSmaxi, this.marvelHeroes[10].TSmaxi, this.marvelHeroes[11].TSmaxi,
           this.marvelHeroes[12].TSmaxi], tension: 0.5
          },
          {
            label: 'lisa', data: [this.marvelHeroes[0].TSlisa, this.marvelHeroes[1].TSlisa, this.marvelHeroes[2].TSlisa,
            this.marvelHeroes[3].TSlisa, this.marvelHeroes[4].TSlisa, this.marvelHeroes[5].TSlisa, this.marvelHeroes[6].TSlisa,
            this.marvelHeroes[7].TSlisa, this.marvelHeroes[8].TSlisa, this.marvelHeroes[9].TSlisa, this.marvelHeroes[10].TSlisa, this.marvelHeroes[11].TSlisa,
           this.marvelHeroes[12].TSlisa], tension: 0.5
          },
        ];


        this.HolzzuTagData.labels = ['2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026'];
        this.HolzzuTagData.datasets = [
          {
            label: 'Thomas', data: [this.marvelHeroes[0].h_thomas, this.marvelHeroes[1].h_thomas, this.marvelHeroes[2].h_thomas,
            this.marvelHeroes[3].h_thomas, this.marvelHeroes[4].h_thomas, this.marvelHeroes[5].h_thomas,
            this.marvelHeroes[6].h_thomas, this.marvelHeroes[7].h_thomas, this.marvelHeroes[8].h_thomas,
            this.marvelHeroes[9].h_thomas,this.marvelHeroes[10].h_thomas,this.marvelHeroes[11].h_thomas,
            ,this.marvelHeroes[12].h_thomas
            ], tension: 0.5
          },
          {
            label: 'Michi', data: [this.marvelHeroes[0].h_michi,
            this.marvelHeroes[1].h_michi,
            this.marvelHeroes[2].h_michi,
            this.marvelHeroes[3].h_michi,
            this.marvelHeroes[4].h_michi,
            this.marvelHeroes[5].h_michi,
            this.marvelHeroes[6].h_michi,
            this.marvelHeroes[7].h_michi,
            this.marvelHeroes[8].h_michi,
            this.marvelHeroes[9].h_michi,
            this.marvelHeroes[10].h_michi,
            this.marvelHeroes[11].h_michi,
           this.marvelHeroes[12].h_michi], tension: 0.5
          },
          {
            label: 'Tobi', data: [this.marvelHeroes[0].hsch_tobi,
            this.marvelHeroes[1].h_tobi,
            this.marvelHeroes[2].h_tobi,
            this.marvelHeroes[3].h_tobi,
            this.marvelHeroes[4].h_tobi,
            this.marvelHeroes[5].h_tobi,
            this.marvelHeroes[6].h_tobi,
            this.marvelHeroes[7].h_tobi,
            this.marvelHeroes[8].h_tobi,
            this.marvelHeroes[9].h_tobi,this.marvelHeroes[10].h_tobi,
            this.marvelHeroes[11].h_tobi,
            this.marvelHeroes[12].h_tobi], tension: 0.5
          },
          {
            label: 'Joachim', data: [this.marvelHeroes[0].h_joachim, this.marvelHeroes[1].h_joachim,
            this.marvelHeroes[2].h_joachim, this.marvelHeroes[3].h_joachim, this.marvelHeroes[4].h_joachim,
            this.marvelHeroes[5].h_joachim, this.marvelHeroes[6].h_joachim, this.marvelHeroes[7].h_joachim,
            this.marvelHeroes[8].h_joachim, this.marvelHeroes[9].h_joachim,this.marvelHeroes[10].h_joachim,
            this.marvelHeroes[11].h_joachim,
          this.marvelHeroes[12].h_joachim], tension: 0.5
          },
          {
            label: 'Christian', data: [this.marvelHeroes[0].h_christian, this.marvelHeroes[1].h_christian,
            this.marvelHeroes[2].h_christian, this.marvelHeroes[3].h_christian, this.marvelHeroes[4].h_christian,
            this.marvelHeroes[5].h_christian, this.marvelHeroes[6].h_christian, this.marvelHeroes[7].h_christian,
            this.marvelHeroes[8].h_christian,  this.marvelHeroes[9].h_christian,  this.marvelHeroes[10].h_christian,
            this.marvelHeroes[11].h_christian,
          this.marvelHeroes[12].h_christian], tension: 0.5
          },
          {
            label: 'Josef', data: [this.marvelHeroes[0].h_josef,
            this.marvelHeroes[1].h_josef,
            this.marvelHeroes[2].h_josef,
            this.marvelHeroes[3].h_josef,
            this.marvelHeroes[4].h_josef,
            this.marvelHeroes[5].h_josef,
            this.marvelHeroes[6].h_josef,
            this.marvelHeroes[7].h_josef,
            this.marvelHeroes[8].h_josef,
            this.marvelHeroes[9].h_josef,
            this.marvelHeroes[10].h_josef,
            this.marvelHeroes[11].h_josef,
           this.marvelHeroes[12].h_josef], tension: 0.5
          },
          {
            label: 'Luggi', data: [this.marvelHeroes[0].h_luggi,
            this.marvelHeroes[1].h_luggi,
            this.marvelHeroes[2].h_luggi,
            this.marvelHeroes[3].h_luggi,
            this.marvelHeroes[4].h_luggi,
            this.marvelHeroes[5].h_luggi,
            this.marvelHeroes[6].h_luggi,
            this.marvelHeroes[7].h_luggi,
            this.marvelHeroes[8].h_luggi,
            this.marvelHeroes[9].h_luggi,
            this.marvelHeroes[10].h_luggi,
            this.marvelHeroes[11].h_luggi,
          this.marvelHeroes[12].h_luggi], tension: 0.5
          },
          {
            label: 'Flori', data: [this.marvelHeroes[0].h_flori,
            this.marvelHeroes[1].h_flori,
            this.marvelHeroes[2].h_flori,
            this.marvelHeroes[3].h_flori,
            this.marvelHeroes[4].h_flori,
            this.marvelHeroes[5].h_flori,
            this.marvelHeroes[6].h_flori,
            this.marvelHeroes[7].h_flori,
            this.marvelHeroes[8].h_flori,
            this.marvelHeroes[9].h_flori,
            this.marvelHeroes[10].h_flori,
            this.marvelHeroes[11].h_flori,
             this.marvelHeroes[12].h_flori
            ], tension: 0.5
          },
          {
            label: 'Laurin', data: [this.marvelHeroes[0].h_laurin,
            this.marvelHeroes[1].h_laurin,
            this.marvelHeroes[2].h_laurin,
            this.marvelHeroes[3].h_laurin,
            this.marvelHeroes[4].h_laurin,
            this.marvelHeroes[5].h_laurin,
            this.marvelHeroes[6].h_laurin,
            this.marvelHeroes[7].h_laurin,
            this.marvelHeroes[8].h_laurin,
            this.marvelHeroes[9].h_laurin,
            this.marvelHeroes[10].h_laurin,
            this.marvelHeroes[11].h_laurin,
          this.marvelHeroes[12].h_laurin]
            , tension: 0.5
          },
          {
            label: 'Linus', data: [this.marvelHeroes[0].h_linus,
            this.marvelHeroes[1].h_linus, this.marvelHeroes[2].h_linus, this.marvelHeroes[3].h_linus,
            this.marvelHeroes[4].h_linus, this.marvelHeroes[5].h_linus,
            this.marvelHeroes[6].h_linus,
            this.marvelHeroes[7].h_linus,
            this.marvelHeroes[8].h_linus,
            this.marvelHeroes[9].h_linus,  this.marvelHeroes[10].h_linus,
            this.marvelHeroes[11].h_linus,
             this.marvelHeroes[12].h_linus
            ], tension: 0.5
          },
          {
            label: 'maxi', data: [this.marvelHeroes[0].h_maxi,
            this.marvelHeroes[1].h_maxi,
            this.marvelHeroes[2].h_maxi,
            this.marvelHeroes[3].h_maxi,
            this.marvelHeroes[4].h_maxi,
            this.marvelHeroes[5].h_maxi,
            this.marvelHeroes[6].h_maxi,
            this.marvelHeroes[7].h_maxi,
            this.marvelHeroes[8].h_maxi,
            this.marvelHeroes[9].h_maxi,
            this.marvelHeroes[10].h_maxi,
            this.marvelHeroes[11].h_maxi,
            this.marvelHeroes[12].h_maxi
            ], tension: 0.5
          },
          {
            label: 'lisa', data: [this.marvelHeroes[0].h_lisa,
            this.marvelHeroes[1].h_lisa,
            this.marvelHeroes[2].h_lisa,
            this.marvelHeroes[3].h_lisa,
            this.marvelHeroes[4].h_lisa,
            this.marvelHeroes[5].h_lisa,
            this.marvelHeroes[6].h_lisa,
            this.marvelHeroes[7].h_lisa,
            this.marvelHeroes[8].h_lisa,
            this.marvelHeroes[9].h_lisa,
            this.marvelHeroes[10].h_lisa,
            this.marvelHeroes[11].h_lisa,
             this.marvelHeroes[12].h_lisa
            ], tension: 0.5
          },
        ];


     
        this.TagschichtenData.labels = ['Ø/13 Leute', 'michi', 'thomas', 'joachim', 'tobi', 'robert',
          'christian', 'josef', 'luggi', 'flori', 'laurin', 'linus', 'maxi', 'lisa'];
        this.TagschichtenData.datasets = [
          {
            label: 'Holz', data: [this.sum_gesamtholz / 13, this.sum_hmichi, this.sum_hthomas, this.sum_hjoachim, this.sum_htobi, this.sum_hrobert,
            this.sum_hchristian, this.sum_hjosef, this.sum_hluggi, this.sum_hflori, this.sum_hlaurin, this.sum_hlinus, this.sum_hmaxi,this.sum_hlisa], backgroundColor: 'brown'
          },
          {
            label: 'Tagschichten', data: [this.sum_gesamttagschicht / 13, this.sum_TSmichi, this.sum_TSthomas, this.sum_TSjoachim, this.sum_TStobi, this.sum_TSrobert,
            this.sum_TSchristian, this.sum_TSjosef, this.sum_TSluggi, this.sum_TSflori, this.sum_TSlaurin, this.sum_TSlinus, this.sum_TSmaxi, this.sum_TSlisa], backgroundColor: 'blue'
          },
        ];

        const backgroundcolor = [];

        this.HolzzuTagschichtenData.labels = [ 'michi', 'thomas', 'joachim', 'tobi', 'robert',
          'christian', 'josef', 'luggi', 'flori', 'laurin', 'linus', 'maxi', 'lisa'];
     //   for (let i = 0; i < this.HolzzuTagschichtenData.labels.length; i++) {
      //    backgroundcolor.push('rgba(33,33,33,0.3)');
       // }


        this.HolzzuTagschichtenData.datasets = [
     /*     {
            label: 'Holz/Tag', data: [this.sum_gesamtholz / this.sum_gesamttagschicht, this.sum_hmichi / this.sum_TSmichi, this.sum_hthomas / this.sum_TSthomas, this.sum_hjoachim / this.sum_TSjoachim, this.sum_htobi / this.sum_TStobi, this.sum_hrobert / this.sum_TSrobert,
            this.sum_hchristian / this.sum_TSchristian, this.sum_hjosef / this.sum_TSjosef, this.sum_hluggi / this.sum_TSluggi, this.sum_hflori / this.sum_TSflori, this.sum_hlaurin / this.sum_TSlaurin, this.sum_hlinus / this.sum_TSlinus, this.sum_hmaxi / this.sum_TSmaxi, 
            this.sum_hlisa / this.sum_TSlisa], backgroundColor: 'brown'
          },*/
          {
            label:"Tagschichten/Holz" , data: [this.sum_TSmichi / this.sum_hmichi, this.sum_TSthomas / this.sum_hthomas, this.sum_TSjoachim / this.sum_hjoachim, this.sum_TStobi / this.sum_htobi, this.sum_TSrobert / this.sum_hrobert,
            this.sum_TSchristian / this.sum_hchristian, this.sum_TSjosef / this.sum_hjosef, this.sum_TSluggi / this.sum_hluggi, this.sum_TSflori / this.sum_hflori, this.sum_TSlaurin / this.sum_hlaurin, this.sum_TSlinus / this.sum_hlinus, this.sum_TSmaxi / this.sum_hmaxi,
            this.sum_TSlisa / this.sum_hlisa],backgroundColor: 'blue', order: 2

        /*    borderColor: function (context, options) {
              const color = options.color; // resolve the value of another scriptable option: 'red', 'blue' or 'green'
              return 'red';
            }*/

          },
        {
          label: 'Durchschnitt',
          data: [this.sum_gesamttagschicht / this.sum_gesamtholz,
          this.sum_gesamttagschicht / this.sum_gesamtholz,
          this.sum_gesamttagschicht / this.sum_gesamtholz,
          this.sum_gesamttagschicht / this.sum_gesamtholz,
          this.sum_gesamttagschicht / this.sum_gesamtholz,
          this.sum_gesamttagschicht / this.sum_gesamtholz,
          this.sum_gesamttagschicht / this.sum_gesamtholz,
          this.sum_gesamttagschicht / this.sum_gesamtholz,
          this.sum_gesamttagschicht / this.sum_gesamtholz,
          this.sum_gesamttagschicht / this.sum_gesamtholz,
          this.sum_gesamttagschicht / this.sum_gesamtholz,
          this.sum_gesamttagschicht / this.sum_gesamtholz,
          this.sum_gesamttagschicht / this.sum_gesamtholz],
          borderColor: 'green',
          backgroundColor: 'green',
          pointBorderColor: 'green',
          pointBackgroundColor: 'green',
          type: 'line',
          order: 1,
          borderWidth: 9
        }];


        
  /*      
        if ((this.sum_TSmichi / this.sum_hmichi)<(this.sum_gesamttagschicht / this.sum_gesamtholz))
        {
            this.HolzzuTagschichtenData.datasets[0].borderColor='rgba(255,0,0,0.2)';
            this.HolzzuTagschichtenData.datasets[0].borderWidth=3;//'rgba(255,0,0,0.2)';
        }
        else{
            this.HolzzuTagschichtenData.datasets[0].borderColor='rgba(0,255,0,0.2)';
            this.HolzzuTagschichtenData.datasets[0].borderWidth=8;
        };


        if (1>0)
        {
              this.HolzzuTagschichtenData.datasets[2].borderColor='rgba(255,0,0,0.2)';
              this.HolzzuTagschichtenData.datasets[2].borderWidth=3;
        }
        else{
              this.HolzzuTagschichtenData.datasets[2].borderColor='rgba(0,255,0,0.2)';
              this.HolzzuTagschichtenData.datasets[2].borderWidth=8;
        };

*/

        this.pieTagzuHolzData.labels = ['Ø','michi', 'thomas', 'joachim', 'tobi', 'robert',
          'christian', 'josef', 'luggi', 'flori', 'laurin', 'linus', 'maxi', 'lisa'];

          


        // Verlauf Holz zu Tag Mi
        var arr_temp_h = [];
        for (let i = 0; i < 13; i++) {
          arr_temp_h.push(this.marvelHeroes[i].h_michi);
        }
        var arr_temp_t = [];
        for (let i = 0; i < 13; i++) {
          arr_temp_t.push(this.marvelHeroes[i].TSmichi);
        }

        var verlauf_michi_holzuTag = [];
  
  

        verlauf_michi_holzuTag = this.createVerlauf(arr_temp_h, arr_temp_t);
        
     

// Thomas
arr_temp_h = [];
arr_temp_t = [];
for (let i = 0; i < 13; i++) {
  arr_temp_h.push(this.marvelHeroes[i].h_thomas);
}
for (let i = 0; i < 13; i++) {
  arr_temp_t.push(this.marvelHeroes[i].TSthomas);
}
var verlauf_thomas_holzuTag = [];
verlauf_thomas_holzuTag = this.createVerlauf(arr_temp_h, arr_temp_t);

// Tobi
arr_temp_h = [];
arr_temp_t = [];
for (let i = 0; i < 13; i++) {
  arr_temp_h.push(this.marvelHeroes[i].h_tobi);
}
for (let i = 0; i < 13; i++) {
  arr_temp_t.push(this.marvelHeroes[i].TStobi);
}
var verlauf_tobi_holzuTag = [];
verlauf_tobi_holzuTag = this.createVerlauf(arr_temp_h, arr_temp_t);

// Joachim
arr_temp_h = [];
arr_temp_t = [];
for (let i = 0; i < 13; i++) {
  arr_temp_h.push(this.marvelHeroes[i].h_joachim);
}
for (let i = 0; i < 13; i++) {
  arr_temp_t.push(this.marvelHeroes[i].TSjoachim);
}
var verlauf_joachim_holzuTag = [];
verlauf_joachim_holzuTag = this.createVerlauf(arr_temp_h, arr_temp_t);

// Seni
arr_temp_h = [];
arr_temp_t = [];
for (let i = 0; i < 13; i++) {
  arr_temp_h.push(this.marvelHeroes[i].h_christian);
}
for (let i = 0; i < 13; i++) {
  arr_temp_t.push(this.marvelHeroes[i].TSchristian);
}
var verlauf_christian_holzuTag = [];
verlauf_christian_holzuTag = this.createVerlauf(arr_temp_h, arr_temp_t);

// Luggi
arr_temp_h = [];
arr_temp_t = [];
for (let i = 0; i < 13; i++) {
  arr_temp_h.push(this.marvelHeroes[i].h_luggi);
}
for (let i = 0; i < 13; i++) {
  arr_temp_t.push(this.marvelHeroes[i].TSluggi);
}
var verlauf_luggi_holzuTag = [];
verlauf_luggi_holzuTag = this.createVerlauf(arr_temp_h, arr_temp_t);

// Josef
arr_temp_h = [];
arr_temp_t = [];
for (let i = 0; i < 13; i++) {
  arr_temp_h.push(this.marvelHeroes[i].h_josef);
}
for (let i = 0; i < 13; i++) {
  arr_temp_t.push(this.marvelHeroes[i].TSjosef);
}


var verlauf_josef_holzuTag = [];
verlauf_josef_holzuTag = this.createVerlauf(arr_temp_h, arr_temp_t);


// FLori
arr_temp_h = [];
arr_temp_t = [];
for (let i = 0; i < 13; i++) {
  arr_temp_h.push(this.marvelHeroes[i].h_flori);
}
for (let i = 0; i < 13; i++) {
  arr_temp_t.push(this.marvelHeroes[i].TSflori);
}
var verlauf_flori_holzuTag = [];
verlauf_flori_holzuTag = this.createVerlauf(arr_temp_h, arr_temp_t);

// Laurin
arr_temp_h = [];
arr_temp_t = [];
for (let i = 0; i < 13; i++) {
  arr_temp_h.push(this.marvelHeroes[i].h_laurin);
}
for (let i = 0; i < 13; i++) {
  arr_temp_t.push(this.marvelHeroes[i].TSlaurin);
}
var verlauf_laurin_holzuTag = [];
verlauf_laurin_holzuTag = this.createVerlauf(arr_temp_h, arr_temp_t);
// Linus
arr_temp_h = [];
arr_temp_t = [];
for (let i = 0; i < 13; i++) {
  arr_temp_h.push(this.marvelHeroes[i].h_linus);
}
for (let i = 0; i < 13; i++) {
  arr_temp_t.push(this.marvelHeroes[i].TSlinus);
}
var verlauf_linus_holzuTag = [];
verlauf_linus_holzuTag = this.createVerlauf(arr_temp_h, arr_temp_t);
// Maxi
arr_temp_h = [];
arr_temp_t = [];
for (let i = 0; i < 13; i++) {
  arr_temp_h.push(this.marvelHeroes[i].h_maxi);
}
for (let i = 0; i < 13; i++) {
  arr_temp_t.push(this.marvelHeroes[i].TSmaxi);
}
var verlauf_maxi_holzuTag = [];
verlauf_maxi_holzuTag = this.createVerlauf(arr_temp_h, arr_temp_t);
// Lisa
arr_temp_h = [];
arr_temp_t = [];
for (let i = 0; i < 13; i++) {
  arr_temp_h.push(this.marvelHeroes[i].h_lisa);
}
for (let i = 0; i < 13; i++) {
  arr_temp_t.push(this.marvelHeroes[i].TSlisa);
}
var verlauf_lisa_holzuTag = [];
verlauf_lisa_holzuTag = this.createVerlauf(arr_temp_h, arr_temp_t);

//Durchschnitt
// Tag
var arr_durchschnitt_t=[];
var arr_durchschnitt_h=[];
//let tts:number;
for (let i = 0; i < 13; i++) {
  var tts = (parseFloat(this.marvelHeroes[i].TSmichi))+(parseFloat(this.marvelHeroes[i].TSthomas))+
  (parseFloat(this.marvelHeroes[i].TStobi))+ (parseFloat(this.marvelHeroes[i].TSjoachim)) +
  (parseFloat(this.marvelHeroes[i].TSchristian))+(parseFloat(this.marvelHeroes[i].TSjosef))+
  (parseFloat(this.marvelHeroes[i].TSluggi))+(parseFloat(this.marvelHeroes[i].TSlaurin))+
  (parseFloat(this.marvelHeroes[i].TSflori))
  +(parseFloat(this.marvelHeroes[i].TSlinus))+(parseFloat(this.marvelHeroes[i].TSmaxi))+
  +(parseFloat(this.marvelHeroes[i].TSlisa))+ (parseFloat(this.marvelHeroes[i].TSrobert));
 // console.log('josefTsum:' + i + ': ' +  this.marvelHeroes[i].josef);
 // console.log('tt ss:' + i + ': ' +  tts);
  arr_durchschnitt_t.push(tts);
  console.log('tts' + tts);
  var hh=(parseFloat(this.marvelHeroes[i].h_michi))+(parseFloat(this.marvelHeroes[i].h_thomas))+
  (parseFloat(this.marvelHeroes[i].h_tobi))+ (parseFloat(this.marvelHeroes[i].h_joachim)) +
  (parseFloat(this.marvelHeroes[i].h_christian))+(parseFloat(this.marvelHeroes[i].h_josef))+
  (parseFloat(this.marvelHeroes[i].h_luggi))+(parseFloat(this.marvelHeroes[i].h_laurin))+
  (parseFloat(this.marvelHeroes[i].h_flori))
  +(parseFloat(this.marvelHeroes[i].h_linus))+(parseFloat(this.marvelHeroes[i].h_maxi))+
  (parseFloat(this.marvelHeroes[i].h_lisa))+ (parseFloat(this.marvelHeroes[i].h_robert));

  //  console.log('hh ss:' + i + ': ' +  hh);
  arr_durchschnitt_h.push(hh);
  console.log('FR' + hh);
}


var verlauf_durchschnitt_holzuTag = [];
verlauf_durchschnitt_holzuTag = this.createVerlauf(arr_durchschnitt_h, arr_durchschnitt_t);

var verlauf_durchschnitt_TagzuHolz=[];
var verlauf_michi_TzuH=[];
var verlauf_thomas_TzuH=[];
var verlauf_joachim_TzuH=[];
var verlauf_tobi_TzuH=[];
var verlauf_robert_TzuH=[];
var verlauf_josef_TzuH=[];
var verlauf_luggi_TzuH=[];
var verlauf_laurin_TzuH=[];
var verlauf_linus_TzuH=[];
var verlauf_flori_TzuH=[];
var verlauf_maxi_TzuH=[];
var verlauf_lisa_TzuH=[];
var verlauf_christian_TzuH=[];



for (let i = 0; i < 13; i++)
{
//tat.sort((a, b) => (a < b ? -1 : 1));
  verlauf_durchschnitt_TagzuHolz.push(verlauf_durchschnitt_holzuTag[i]<=0 ? 0 : 1/verlauf_durchschnitt_holzuTag[i]);
  verlauf_michi_TzuH.push(verlauf_michi_holzuTag[i]<=0 ? 0: 1/ verlauf_michi_holzuTag[i]);
  verlauf_thomas_TzuH.push(verlauf_thomas_holzuTag[i]<=0 ? 0: 1/ verlauf_thomas_holzuTag[i]);
  verlauf_tobi_TzuH.push(verlauf_tobi_holzuTag[i]<=0 ? 0: 1/ verlauf_tobi_holzuTag[i]);
  verlauf_joachim_TzuH.push(verlauf_joachim_holzuTag[i]<=0 ? 0: 1/ verlauf_joachim_holzuTag[i]);
  verlauf_josef_TzuH.push(verlauf_josef_holzuTag[i]<=0 ? 0: 1/ verlauf_josef_holzuTag[i]);
  verlauf_luggi_TzuH.push(verlauf_luggi_holzuTag[i]<=0 ? 0: 1/ verlauf_luggi_holzuTag[i]);
  verlauf_flori_TzuH.push(verlauf_flori_holzuTag[i]<=0 ? 0: 1/ verlauf_flori_holzuTag[i]);
  verlauf_laurin_TzuH.push(verlauf_laurin_holzuTag[i]<=0 ? 0: 1/ verlauf_laurin_holzuTag[i]);
  verlauf_linus_TzuH.push(verlauf_linus_holzuTag[i]<=0 ? 0: 1/ verlauf_linus_holzuTag[i]);
  verlauf_christian_TzuH.push(verlauf_christian_holzuTag[i]<=0 ? 0: 1/ verlauf_christian_holzuTag[i]);
  verlauf_lisa_TzuH.push(verlauf_lisa_holzuTag[i]<=0 ? 0: 1/ verlauf_lisa_holzuTag[i]);
  verlauf_maxi_TzuH.push(verlauf_maxi_holzuTag[i]<=0 ? 0: 1/ verlauf_maxi_holzuTag[i]);

}

console.log("Build verlauf_durchschnitt_TagzuHolz:" + verlauf_durchschnitt_TagzuHolz);

        this.verlauf_labels= [ '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023','2024', '2025', '2026'];

        this.VerlaufData.labels = this.verlauf_labels;//[ '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022'];

        this.VerlaufData.datasets = [
   
          {
            label: 'Ø', data: [verlauf_durchschnitt_holzuTag[1],verlauf_durchschnitt_holzuTag[2],
            verlauf_durchschnitt_holzuTag[3],verlauf_durchschnitt_holzuTag[4],verlauf_durchschnitt_holzuTag[5],
            verlauf_durchschnitt_holzuTag[6],verlauf_durchschnitt_holzuTag[7],verlauf_durchschnitt_holzuTag[8],
            verlauf_durchschnitt_holzuTag[9],   verlauf_durchschnitt_holzuTag[10],verlauf_durchschnitt_holzuTag[11],
            verlauf_durchschnitt_holzuTag[12],      
           ], tension: 0.9,
           borderWidth: 10,
           borderColor: 'red',    
           backgroundColor: 'red',
           borderDashOffset: 4,
           borderDash: [10,10],
         //  pointBorderWidth:40,
        //   pointHitRadius: 90,
           pointRadius: 2,
           pointBackgroundColor: 'red',
           
                       
      
          },
          
            {
              label: 'Michi', data: [verlauf_michi_holzuTag[1],verlauf_michi_holzuTag[2],
              verlauf_michi_holzuTag[3],verlauf_michi_holzuTag[4],verlauf_michi_holzuTag[5],
              verlauf_michi_holzuTag[6],verlauf_michi_holzuTag[7],verlauf_michi_holzuTag[8],
              verlauf_michi_holzuTag[9],verlauf_michi_holzuTag[10],verlauf_michi_holzuTag[11]
              ,verlauf_michi_holzuTag[12]       
             ], tension: 0.0
            },
            {
              label: 'Thomas', data: [verlauf_thomas_holzuTag[1],verlauf_thomas_holzuTag[2],
              verlauf_thomas_holzuTag[3],verlauf_thomas_holzuTag[4],verlauf_thomas_holzuTag[5],
              verlauf_thomas_holzuTag[6],verlauf_thomas_holzuTag[7],verlauf_thomas_holzuTag[8],
              verlauf_thomas_holzuTag[9], verlauf_thomas_holzuTag[10],  verlauf_thomas_holzuTag[11],
              verlauf_thomas_holzuTag[12]     
             ], tension: 0.0
            },
            {
              label: 'Tobi', data: [verlauf_tobi_holzuTag[1],verlauf_tobi_holzuTag[2],
              verlauf_tobi_holzuTag[3],verlauf_tobi_holzuTag[4],verlauf_tobi_holzuTag[5],
              verlauf_tobi_holzuTag[6],verlauf_tobi_holzuTag[7],verlauf_tobi_holzuTag[8],
              verlauf_tobi_holzuTag[9],verlauf_tobi_holzuTag[10], verlauf_tobi_holzuTag[11],
              verlauf_tobi_holzuTag[12]     
             ], tension: 0.0
            },
            {
              label: 'joachim', data: [verlauf_joachim_holzuTag[1],verlauf_joachim_holzuTag[2],
              verlauf_joachim_holzuTag[3],verlauf_joachim_holzuTag[4],verlauf_joachim_holzuTag[5],
              verlauf_joachim_holzuTag[6],verlauf_joachim_holzuTag[7],verlauf_joachim_holzuTag[8],
              verlauf_joachim_holzuTag[9],verlauf_joachim_holzuTag[10], verlauf_joachim_holzuTag[11],
              verlauf_joachim_holzuTag[12]  
             ], tension: 0.0
            },
            {
              label: 'christian', data: [verlauf_christian_holzuTag[1],verlauf_christian_holzuTag[2],
              verlauf_christian_holzuTag[3],verlauf_christian_holzuTag[4],verlauf_christian_holzuTag[5],
              verlauf_christian_holzuTag[6],verlauf_christian_holzuTag[7],verlauf_christian_holzuTag[8],
              verlauf_christian_holzuTag[9], verlauf_christian_holzuTag[10], verlauf_christian_holzuTag[11],
                verlauf_christian_holzuTag[12],
             ], tension: 0.0
            },
            {
              label: 'luggi', data: [verlauf_luggi_holzuTag[1],verlauf_luggi_holzuTag[2],
              verlauf_luggi_holzuTag[3],verlauf_luggi_holzuTag[4],verlauf_luggi_holzuTag[5],
              verlauf_luggi_holzuTag[6],verlauf_luggi_holzuTag[7],verlauf_luggi_holzuTag[8],
              verlauf_luggi_holzuTag[9],verlauf_luggi_holzuTag[10],verlauf_luggi_holzuTag[11],
              verlauf_luggi_holzuTag[12]
             ], tension: 0.0
            },
            {
              label: 'josef', data: [verlauf_josef_holzuTag[1],verlauf_josef_holzuTag[2],
              verlauf_josef_holzuTag[3],verlauf_josef_holzuTag[4],verlauf_josef_holzuTag[5],
              verlauf_josef_holzuTag[6],verlauf_josef_holzuTag[7],verlauf_josef_holzuTag[8],
              verlauf_josef_holzuTag[9],verlauf_josef_holzuTag[10],verlauf_josef_holzuTag[11],
                   verlauf_josef_holzuTag[12]
             ], tension: 0.0
            },
            {
              label: 'flori', data: [verlauf_flori_holzuTag[1],verlauf_flori_holzuTag[2],
              verlauf_flori_holzuTag[3],verlauf_flori_holzuTag[4],verlauf_flori_holzuTag[5],
              verlauf_flori_holzuTag[6],verlauf_flori_holzuTag[7],verlauf_flori_holzuTag[8],
              verlauf_flori_holzuTag[9],verlauf_flori_holzuTag[10],verlauf_flori_holzuTag[11],
              verlauf_flori_holzuTag[12]       
             ], tension: 0.0
            },
            {
              label: 'laurin', data: [verlauf_laurin_holzuTag[1],verlauf_laurin_holzuTag[2],
              verlauf_laurin_holzuTag[3],verlauf_laurin_holzuTag[4],verlauf_laurin_holzuTag[5],
              verlauf_laurin_holzuTag[6],verlauf_laurin_holzuTag[7],verlauf_laurin_holzuTag[8],
              verlauf_laurin_holzuTag[9],verlauf_laurin_holzuTag[10],verlauf_laurin_holzuTag[11],
              verlauf_laurin_holzuTag[12]      
             ], tension: 0.0
            },
            {
              label: 'linus', data: [verlauf_linus_holzuTag[1],verlauf_linus_holzuTag[2],
              verlauf_linus_holzuTag[3],verlauf_linus_holzuTag[4],verlauf_linus_holzuTag[5],
              verlauf_linus_holzuTag[6],verlauf_linus_holzuTag[7],verlauf_linus_holzuTag[8],
              verlauf_linus_holzuTag[9],verlauf_linus_holzuTag[10],verlauf_linus_holzuTag[11],
              ,verlauf_linus_holzuTag[12]
             ], tension: 0.0
            },
            {
              label: 'maxi', data: [verlauf_maxi_holzuTag[1],verlauf_maxi_holzuTag[2],
              verlauf_maxi_holzuTag[3],verlauf_maxi_holzuTag[4],verlauf_maxi_holzuTag[5],
              verlauf_maxi_holzuTag[6],verlauf_maxi_holzuTag[7],verlauf_maxi_holzuTag[8],
              verlauf_maxi_holzuTag[9], verlauf_maxi_holzuTag[10],verlauf_maxi_holzuTag[11],
              ,verlauf_maxi_holzuTag[12]       
             ], tension: 0.0
            },
            {
              label: 'lisa', data: [verlauf_lisa_holzuTag[1],verlauf_lisa_holzuTag[2],
              verlauf_lisa_holzuTag[3],verlauf_lisa_holzuTag[4],verlauf_lisa_holzuTag[5],
              verlauf_lisa_holzuTag[6],verlauf_lisa_holzuTag[7],verlauf_lisa_holzuTag[8],
              verlauf_lisa_holzuTag[9], verlauf_lisa_holzuTag[10], verlauf_lisa_holzuTag[11],
               verlauf_lisa_holzuTag[12]   
             ], tension: 0.0
            },
        ];

   
        this.verlauf_labels = [ '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023','2024','2025', '2026'];
        this.verlauf_data=this.VerlaufData.datasets;

        this.VerlaufTagzuHolzData.labels=this.verlauf_labels;

        this.VerlaufTagzuHolzData.datasets= [
   

  //        verlauf_durchschnitt_TagzuHolz.push(verlauf_durchschnitt_holzuTag[i]<=0 ? 0 : 1/verlauf_durchschnitt_holzuTag[i]);
  //verlauf_michi_TzuH.push(verlauf_michi_holzuTag[i]<=0 ? 0: 1/ verlauf_michi_holzuTag[i]);
 
          {
            label: 'Ø', data: [
              verlauf_durchschnitt_TagzuHolz[1],
              verlauf_durchschnitt_TagzuHolz[2],verlauf_durchschnitt_TagzuHolz[3],
              verlauf_durchschnitt_TagzuHolz[4],verlauf_durchschnitt_TagzuHolz[5],
              verlauf_durchschnitt_TagzuHolz[6],verlauf_durchschnitt_TagzuHolz[7],
              verlauf_durchschnitt_TagzuHolz[8], verlauf_durchschnitt_TagzuHolz[9],
              verlauf_durchschnitt_TagzuHolz[10], verlauf_durchschnitt_TagzuHolz[11],
              , verlauf_durchschnitt_TagzuHolz[12]
              
           ], tension: 0.5,
           borderWidth: 5,
           borderColor: 'red',    
           backgroundColor: 'red',
           borderDashOffset: 3,
           borderDash: [5,2],
         //  pointBorderWidth:40,
        //   pointHitRadius: 90,
           pointRadius: 2,
           pointBackgroundColor: 'red',
           
                       
      
          },
       
            {
              label: 'Michi', data: [verlauf_michi_TzuH[1],verlauf_michi_TzuH[2],
              verlauf_michi_TzuH[3],verlauf_michi_TzuH[4],verlauf_michi_TzuH[5],
              verlauf_michi_TzuH[6],verlauf_michi_TzuH[7],verlauf_michi_TzuH[8],
              verlauf_michi_TzuH[9],verlauf_michi_TzuH[10],verlauf_michi_TzuH[11],
              verlauf_michi_TzuH[12]
                               
             ], tension: 0.0
            },
            
            {
              label: 'Thomas', data: [verlauf_thomas_TzuH[1],verlauf_thomas_TzuH[2],
              verlauf_thomas_TzuH[3],verlauf_thomas_TzuH[4],verlauf_thomas_TzuH[5],
              verlauf_thomas_TzuH[6],verlauf_thomas_TzuH[7],verlauf_thomas_TzuH[8],
              verlauf_thomas_TzuH[9], verlauf_thomas_TzuH[10], verlauf_thomas_TzuH[11],
              verlauf_thomas_TzuH[12]
             ], tension: 0.0
            },
            {
              label: 'Tobi', data: [verlauf_tobi_TzuH[1],verlauf_tobi_TzuH[2],
              verlauf_tobi_TzuH[3],verlauf_tobi_TzuH[4],verlauf_tobi_TzuH[5],
              verlauf_tobi_TzuH[6],verlauf_tobi_TzuH[7],verlauf_tobi_TzuH[8],
              verlauf_tobi_TzuH[9] ,   verlauf_tobi_TzuH[10],verlauf_tobi_TzuH[11],
                verlauf_tobi_TzuH[12]
             ], tension: 0.5
            },
            {
              label: 'joachim', data: [verlauf_joachim_TzuH[1],verlauf_joachim_TzuH[2],
              verlauf_joachim_TzuH[3],verlauf_joachim_TzuH[4],verlauf_joachim_TzuH[5],
              verlauf_joachim_TzuH[6],verlauf_joachim_TzuH[7],verlauf_joachim_TzuH[8],
              verlauf_joachim_TzuH[9], verlauf_joachim_TzuH[10],verlauf_joachim_TzuH[11],
                  verlauf_joachim_TzuH[12]
             ], tension: 0.0
            },
            {
              label: 'christian', data: [verlauf_christian_TzuH[1],verlauf_christian_TzuH[2],
              verlauf_christian_TzuH[3],verlauf_christian_TzuH[4],verlauf_christian_TzuH[5],
              verlauf_christian_TzuH[6],verlauf_christian_TzuH[7],verlauf_christian_TzuH[8],
              verlauf_christian_TzuH[9], verlauf_christian_TzuH[10],verlauf_christian_TzuH[11],
                 verlauf_christian_TzuH[12]
             ], tension: 0.0
            },
            {
              label: 'luggi', data: [verlauf_luggi_TzuH[1],verlauf_luggi_TzuH[2],
              verlauf_luggi_TzuH[3],verlauf_luggi_TzuH[4],verlauf_luggi_TzuH[5],
              verlauf_luggi_TzuH[6],verlauf_luggi_TzuH[7],verlauf_luggi_TzuH[8],
              verlauf_luggi_TzuH[9], verlauf_luggi_TzuH[10],verlauf_luggi_TzuH[11],
              verlauf_luggi_TzuH[12]
             ], tension: 0.5
            },
            {
              label: 'josef', data: [verlauf_josef_TzuH[1],verlauf_josef_TzuH[2],
              verlauf_josef_TzuH[3],verlauf_josef_TzuH[4],verlauf_josef_TzuH[5],
              verlauf_josef_TzuH[6],verlauf_josef_TzuH[7],verlauf_josef_TzuH[8],
              verlauf_josef_TzuH[9], verlauf_josef_TzuH[10],verlauf_josef_TzuH[11],
              verlauf_josef_TzuH[12]   
             ], tension: 0.0
            },
            {
              label: 'flori', data: [verlauf_flori_TzuH[1],verlauf_flori_TzuH[2],
              verlauf_flori_TzuH[3],verlauf_flori_TzuH[4],verlauf_flori_TzuH[5],
              verlauf_flori_TzuH[6],verlauf_flori_TzuH[7],verlauf_flori_TzuH[8],
              verlauf_flori_TzuH[9], verlauf_flori_TzuH[10], verlauf_flori_TzuH[11],
              verlauf_flori_TzuH[12]   
             ], tension: 0.0
            },
            {
              label: 'laurin', data: [verlauf_laurin_TzuH[1],verlauf_laurin_TzuH[2],
              verlauf_laurin_TzuH[3],verlauf_laurin_TzuH[4],verlauf_laurin_TzuH[5],
              verlauf_laurin_TzuH[6],verlauf_laurin_TzuH[7],verlauf_laurin_TzuH[8],
              verlauf_laurin_TzuH[9],  verlauf_laurin_TzuH[10],verlauf_laurin_TzuH[11],
              verlauf_laurin_TzuH[12]
             ], tension: 0.0
            },
            {
              label: 'linus', data: [verlauf_linus_TzuH[1],verlauf_linus_TzuH[2],
              verlauf_linus_TzuH[3],verlauf_linus_TzuH[4],verlauf_linus_TzuH[5],
              verlauf_linus_TzuH[6],verlauf_linus_TzuH[7],verlauf_linus_TzuH[8],
              verlauf_linus_TzuH[9], verlauf_linus_TzuH[10], verlauf_linus_TzuH[11],
                   verlauf_linus_TzuH[12]
             ], tension: 0.0
            },
            {
              label: 'maxi', data: [verlauf_maxi_TzuH[1],verlauf_maxi_TzuH[2],
              verlauf_maxi_TzuH[3],verlauf_maxi_TzuH[4],verlauf_maxi_TzuH[5],
              verlauf_maxi_TzuH[6],verlauf_maxi_TzuH[7],verlauf_maxi_TzuH[8],
              verlauf_maxi_TzuH[9], verlauf_maxi_TzuH[10],verlauf_maxi_TzuH[11],
              verlauf_maxi_TzuH[12]
             ], tension: 0.0
            },
            {
              label: 'lisa', data: [verlauf_lisa_TzuH[1],verlauf_lisa_TzuH[2],
              verlauf_lisa_TzuH[3],verlauf_lisa_TzuH[4],verlauf_lisa_TzuH[5],
              verlauf_lisa_TzuH[6],verlauf_lisa_TzuH[7],verlauf_lisa_TzuH[8],
              verlauf_lisa_TzuH[9],  verlauf_lisa_TzuH[10],verlauf_lisa_TzuH[11],
              verlauf_lisa_TzuH[12]     
             ], tension: 0.0
            },
        ];

      

        this.pieTagzuHolzData.datasets = [
          {
            label: 'Tag/Holz', data: [this.sum_gesamttagschicht / this.sum_gesamtholz,this.sum_TSmichi / this.sum_hmichi, this.sum_TSthomas / this.sum_hthomas, this.sum_TSjoachim / this.sum_hjoachim, this.sum_TStobi / this.sum_htobi, 0,
            this.sum_TSchristian / this.sum_hchristian, this.sum_TSjosef / this.sum_hjosef, this.sum_TSluggi / this.sum_hluggi, this.sum_TSflori / this.sum_hflori,
             this.sum_TSlaurin / this.sum_hlaurin, this.sum_TSlinus / this.sum_hlinus,this.sum_TSmaxi / this.sum_hmaxi,this.sum_TSlisa / this.sum_hlisa],
        /*    backgroundColor: [
              'red',
              'blue',
              'pink',
              'green',
              'gray',
              'yellow',
              'orange',
              'purple',
              'darkgray',
              'lightblue',
              'lightgreen',
            ]*/
          }
        ]

    
      })
  }

 

  chartConfig = {
    type: 'mixed',
    title: {
      text: 'Sample Burndown Chart',
      align: 'left',
      marginLeft: '23%'
    },
    legend: {
      adjustLayout: true,
      verticalAlign: 'middle'
    },
    scaleX: {
      labels: ['Day 1', 'Day 2', 'Day 3', 'Day 4', 'Day 5', 'Day 6', 'Day 7', 'Day 8'] // one label for every datapoint
    },
    scaleY: {
      guide: { // dashed lines
        visible: false
      },
      label: {
        text: 'Remaing effort (hours)',
        fontSize: '14px'
      }
    },
    scaleY2: {
      label: {
        text: 'Remaing and completed tasks',
        fontSize: '14px'
      },
      maxValue: 100,
      minValue: 0,
      step: 25 // can define scale step values or default
    },
    crosshairX: {
      lineColor: '#424242',
      lineGapSize: '4px',
      lineStyle: 'dotted',
      plotLabel: {
        padding: '15px',
        backgroundColor: 'white',
        bold: true,
        borderColor: '#e3e3e3',
        borderRadius: '5px',
        fontColor: '#2f2f2f',
        fontFamily: 'Lato',
        fontSize: '12px',
        shadow: true,
        shadowAlpha: 0.2,
        shadowBlur: 5,
        shadowColor: '#a1a1a1',
        shadowDistance: 4,
        textAlign: 'left'
      },
      scaleLabel: {
        backgroundColor: '#424242'
      }
    },
    series: [{
      type: 'line',
      text: 'Remaining Tasks',
      values: [35, 42, 67, 89, 25, 34, 67, 85].sort().reverse(),
      lineColor: '#42a5f5',
      marker: {
        visible: false
      },
      scales: 'scale-x, scale-y'
    },
    {
      type: 'line',
      text: 'Remaining Effort',
      values: [25, 32, 57, 79, 15, 24, 57, 75].sort().reverse(),
      lineColor: '#5c6bc0',
      marker: {
        type: 'square',
        backgroundColor: '#5c6bc0'
      },
      scales: 'scale-x, scale-y'
    },
    {
      type: 'line',
      text: 'Completed Tasks',
      values: [90, 80, 70, 60, 50, 40, 30, 20],
      lineColor: '#66bb6a',
      marker: {
        visible: false
      },
      scales: 'scale-x, scale-y'
    },
    {
      type: 'bar',
      text: 'Completed Tasks',
      values: [5, 10, 6, 3, 6, 2, 0, 9],
      backgroundColor: '#ffa726',
      scales: 'scale-x, scale-y-2'
    }
    ]
  };

  // RENDER CHARTS
  // -----------------------------

  /*zingchart.render({
    id: 'myChart',
    data: chartConfig,
    height: '100%',
    width: '100%',
  });*/




  createVerlauf(tag_t: any[], h_h: any[]): number[] {

    let inito: number;
    inito=0;
    var arr_user_sumt = [];


    let temp_tag: any[];
let i;

    for (i = 0; i < 13; i++) {
     
        var x;


      x = (tag_t.slice(0, i + 1).reduce<number>(
        (accumulator: number, currentValue) =>
          accumulator + Number(currentValue), inito));

      arr_user_sumt.push(x<=0 ? 0 : x);

    }

    var arr_user_sumh = [];

  

    for (i = 0; i < 13; i++) {
     


var x;
      x = (h_h.slice(0, i + 1).reduce<number>(
        (accumulator: number, currentValue) =>
          accumulator + Number(currentValue), inito));

      arr_user_sumh.push(x<=0? 0 :x);
   }


    var arr_user_tag_zu_holz = [];
    for (let i = 0; i < 13; i++) {
      let y;
 
      y = (parseFloat(arr_user_sumt[i]) / parseFloat(arr_user_sumh[i]));
      if (Number.isNaN(y))
      {
        y=0;
      }
      arr_user_tag_zu_holz.push((y<=0 || Number.isNaN(y)) ? 0 : y);
    }
     return arr_user_tag_zu_holz;
  }



  getChart(): void {



  }

  updateChart()
  {
    return;
    this.VerlaufTagzuHolzData.labels=[];
  //  return;


    let templabels=[];
    templabels=templabels.concat(this.verlauf_labels);
    let temp2labels=[];
    temp2labels=templabels.splice(0,this.myRange - 1);
    this.VerlaufTagzuHolzData.labels=templabels;
    let temp3labels=[];
    temp3labels=temp3labels.concat(this.verlauf_data);
    let temp4labels=[];
    temp4labels=temp3labels.splice(0,this.myRange - 1);

    this.VerlaufTagzuHolzData.datasets=temp3labels;
  //  this.mycanvas.update();

   // this.chart2.update();


  }
  getTotalMichi() {
    return this.KulturP.map(t => t.michi).reduce((acc, value) => acc + value, 0);
  }

  onPasswordInput() {

    if (this.myPassword == "kultur264") {
      this.hidecode = true;
    }
    else {
      this.hidecode = false;
    }
  }




}









